import { podeOportunidades } from "@/utils/oportunidadesPublicas";
import { contagemEstoqueAtiva } from "@/utils/comprasPeriodo";
import { hasModulo, hasPermission } from "@/utils/menuNavigation";
import { pedirTipoFolha } from "@/components/pessoal/folha-calculo/pedidoTipoFolha";
import Vue from "vue";
import VueRouter from "vue-router";
import AuthIllustrationLayout from "../views/Layout/AuthIllustrationLayout";
import DashboardLayout from "../views/Layout/DashboardLayout.vue";
import PageLayout from "../views/Layout/PageLayout";

import EsqueceuSenha from "@/components/EsqueceuSenha";
import CadastroUsuario from "@/components/acessos/Usuarios/CadastroUsuario";
import EditarUsuario from "@/components/acessos/Usuarios/EditarUsuario";
import ListagemUsuarios from "@/components/acessos/Usuarios/ListagemUsuarios";
import PerfilUsuario from "@/components/acessos/Usuarios/PerfilUsuario";
import CadastroPais from "@/components/locais/paises/CadastroPais";
import EditarPais from "@/components/locais/paises/EditarPais";
import ListagemPaises from "@/components/locais/paises/ListagemPaises";
import EditarPedido from "@/components/operacoes/pedidos/EditarPedido";
import ListagemPedidos from "@/components/operacoes/pedidos/ListagemPedidos";
import CadastroFuncionarioAfastamentoTipo from "@/components/pessoal/funcionario-afastamento-tipo/CadastroFuncionarioAfastamentoTipo";
import EditarFuncionarioAfastamentoTipo from "@/components/pessoal/funcionario-afastamento-tipo/EditarFuncionarioAfastamentoTipo";
import ListagemFuncionarioAfastamentoTipos from "@/components/pessoal/funcionario-afastamento-tipo/ListagemFuncionarioAfastamentoTipos";
import CadastroFuncionarioCargo from "@/components/pessoal/funcionario-cargo/CadastroFuncionarioCargo";
import EditarFuncionarioCargo from "@/components/pessoal/funcionario-cargo/EditarFuncionarioCargo";
import ListagemFuncionarioCargos from "@/components/pessoal/funcionario-cargo/ListagemFuncionarioCargos";
import CadastroSupportTeamMember from "@/components/support/support-team-member/CadastroSupportTeamMember";
import EditarSupportTeamMember from "@/components/support/support-team-member/EditarSupportTeamMember";
import ListagemSupportTeamMembers from "@/components/support/support-team-member/ListagemSupportTeamMembers";
import CadastroSupportSubject from "@/components/support/support-subject/CadastroSupportSubject";
import EditarSupportSubject from "@/components/support/support-subject/EditarSupportSubject";
import ListagemSupportSubjects from "@/components/support/support-subject/ListagemSupportSubjects";
import EditarFuncionarioFolhaPagamentoVerba from "@/components/pessoal/funcionario-folha-pagamento-verba/EditarFuncionarioFolhaPagamentoVerba";
import ListagemFuncionarioFolhaPagamentoVerba from "@/components/pessoal/funcionario-folha-pagamento-verba/ListagemFuncionarioFolhaPagamentoVerba";
import CadastroFuncionarioPonto from "@/components/pessoal/funcionario-ponto/CadastroFuncionarioPonto";
import EditarFuncionarioPonto from "@/components/pessoal/funcionario-ponto/EditarFuncionarioPonto";
import ListagemFuncionarioPontos from "@/components/pessoal/funcionario-ponto/ListagemFuncionarioPontos";
import CadastroFuncionarioSindicato from "@/components/pessoal/funcionario-sindicato/CadastroFuncionarioSindicato";
import EditarFuncionarioSindicato from "@/components/pessoal/funcionario-sindicato/EditarFuncionarioSindicato";
import ListagemFuncionarioSindicatos from "@/components/pessoal/funcionario-sindicato/ListagemFuncionarioSindicatos";
// import EditarFuncionarioUniforme from "@/components/pessoal/funcionario-uniforme/EditarUniforme";
// import ListagemFuncionarioUniforme from "@/components/pessoal/funcionario-uniforme/ListagemUniforme";
import EditarFuncionario from "@/components/pessoal/funcionarios/EditarFuncionario";
import ListagemFuncionarios from "@/components/pessoal/funcionarios/ListagemFuncionarios";
import CadastroPedidoConsumivel from "@/components/recursos/pedido-consumivel/CadastroPedido";
import EditarPedidoConsumivel from "@/components/recursos/pedido-consumivel/EditarPedido";
import ListagemPedidoConsumivel from "@/components/recursos/pedido-consumivel/ListagemPedidos";
import CadastroPedidoMaterial from "@/components/recursos/pedido-material/CadastroPedido";
import EditarPedidoMaterial from "@/components/recursos/pedido-material/EditarPedido";
import ListagemPedidoMaterial from "@/components/recursos/pedido-material/ListagemPedidos";
import CadastroPedidoUniforme from "@/components/recursos/pedido-uniforme/CadastroPedido";
import EditarPedidoUniforme from "@/components/recursos/pedido-uniforme/EditarPedido";
import ListagemPedidoUniforme from "@/components/recursos/pedido-uniforme/ListagemPedidos";
import CadastroInquilino from "@/components/software/inquilinos/CadastroInquilino";
import EditarInquilino from "@/components/software/inquilinos/EditarInquilino";
import ListagemInquilinos from "@/components/software/inquilinos/ListagemInquilinos";
import ListagemLogAuditoria from "@/components/software/log-auditoria/ListagemLogAuditoria.vue";
import ListagemOperacaoPendenteTransacao from "@/components/software/operacoes-pendentes-transacoes/ListagemOperacaoPendenteTransacao.vue";
import store from "@/store";
import {
  SUPPORT_SCOPE_INTERNAL,
  SUPPORT_SCOPE_PROJECT,
  hasInternalSupport,
  hasInternalSupportPermission,
  hasProjectSupportPermission,
  resolveCurrentTenant,
} from "@/utils/supportContext";

import CadastroAvisoPrevio from "@/components/pessoal/funcionario-aviso-previo/CadastroAvisoPrevio";
import EditarAvisoPrevio from "@/components/pessoal/funcionario-aviso-previo/EditarAvisoPrevio";
import ListagemAvisoPrevio from "@/components/pessoal/funcionario-aviso-previo/ListagemAvisoPrevio";

import CadastroFuncionarioPreContratracaoDocumentos from "@/components/pessoal/funcionario-pre-contratacao-documentos/CadastroFuncionarioPreContratracaoDocumentos";
import EditarFuncionarioPreContratracaoDocumentos from "@/components/pessoal/funcionario-pre-contratacao-documentos/EditarFuncionarioPreContratracaoDocumentos";
import ListagemFuncionarioPreContratracaoDocumentos from "@/components/pessoal/funcionario-pre-contratacao-documentos/ListagemFuncionarioPreContratracaoDocumentos";
import CadastroFuncionarioPreContratracao from "@/components/pessoal/funcionario-pre-contratacao/CadastroFuncionarioPreContratracao";
import EditarFuncionarioPreContratracao from "@/components/pessoal/funcionario-pre-contratacao/EditarFuncionarioPreContratracao";
import ListagemFuncionarioPreContratracao from "@/components/pessoal/funcionario-pre-contratacao/ListagemFuncionarioPreContratracao";
import CadastroModeloDocumentacaoAcessoria from "@/components/pessoal/modelo-documentacao-acessoria/CadastroModeloDocumentacaoAcessoria";
import EditarModeloDocumentacaoAcessoria from "@/components/pessoal/modelo-documentacao-acessoria/EditarModeloDocumentacaoAcessoria";
import ListagemModeloDocumentacaoAcessoria from "@/components/pessoal/modelo-documentacao-acessoria/ListagemModeloDocumentacaoAcessoria";

import ListageOrcamentoDespesa from "@/components/financeiro/orcamento-despesa/ListagemOrcamentoDespesa";
// Dashboard pages
const Dashboard = () => import("../views/Dashboard/Dashboard.vue");

Vue.use(VueRouter);
const getPasswordRecoveryTokenFromAddressBar = () => {
  if (typeof window === "undefined") {
    return "";
  }

  const token = new URLSearchParams(window.location.search).get("token");
  return token ? String(token).trim() : "";
};

const isPasswordRecoveryPathInAddressBar = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const normalizedPath = (window.location.pathname || "").replace(/\/+$/, "");
  return normalizedPath.endsWith("/recuperar-senha");
};

const PASSWORD_CHANGE_PATH = "/dashboard/usuario";

const isPasswordChangeRoute = (to) => {
  return to?.path === PASSWORD_CHANGE_PATH || to?.name === "Usuário";
};

const isPasswordRecoveryWithToken = (to, tokenFromAddressBar) => {
  return (
    to?.path === "/recuperar-senha" &&
    Boolean(to?.query?.token || tokenFromAddressBar)
  );
};

const ifNotAuthenticated = (to, from, next) => {
  if (to?.query?.token) {
    next();
    return;
  }
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  next("dashboard");
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next("login");
};

const userHasPermission = (permission) => {
  return (
    Array.isArray(store.state?.permissoes) &&
    store.state.permissoes.includes(permission)
  );
};

const userHasAnyPermission = (permissions = []) => {
  return permissions.some((permission) => userHasPermission(permission));
};

const userHasScopedSupportPermission = (level, requestedScope = null) => {
  const normalizedScope = String(requestedScope || "").toUpperCase();
  const hasProjectPermission = hasProjectSupportPermission(store.state, level);
  const hasInternalPermission =
    hasInternalSupportPermission(store.state, level) &&
    hasInternalSupport(resolveCurrentTenant(store.state));

  if (normalizedScope === SUPPORT_SCOPE_PROJECT) {
    return hasProjectPermission;
  }
  if (normalizedScope === SUPPORT_SCOPE_INTERNAL) {
    return hasInternalPermission;
  }
  return hasProjectPermission || hasInternalPermission;
};

const requestedSupportScope = (route) =>
  route?.meta?.supportScope || route?.query?.escopo;

const ifAuthenticatedSupportList = (to, from, next) => {
  if (
    store.getters.isAuthenticated &&
    userHasScopedSupportPermission("LIST", requestedSupportScope(to))
  ) {
    next();
    return;
  }
  next("/dashboard");
};

const ifAuthenticatedSupportAttendant = (to, from, next) => {
  if (
    store.getters.isAuthenticated &&
    userHasScopedSupportPermission("ATENDIMENTO", requestedSupportScope(to))
  ) {
    next();
    return;
  }
  next("/dashboard");
};

const ifAuthenticatedSupportConfiguration = (permission) => {
  return (to, from, next) => {
    if (
      store.getters.isAuthenticated &&
      userHasPermission(permission) &&
      userHasScopedSupportPermission(null, requestedSupportScope(to))
    ) {
      next();
      return;
    }
    next("/dashboard");
  };
};

const ifAuthenticatedSupportClient = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next("login");
    return;
  }

  if (userHasPermission("ROLE_SuporteCliente_List")) {
    next();
    return;
  }

  next("/dashboard");
};

const ifAuthenticatedMeuInventario = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next("login");
    return;
  }

  if (userHasPermission("ROLE_ProdutoCentroEstoque_Inventario")) {
    next();
    return;
  }

  next("/dashboard");
};

// Telas do cálculo da folha: exige uma das permissões da rota.
const ifAuthenticatedFolhaCalculo = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next("login");
    return;
  }
  if (userHasAnyPermission(to.meta?.permissions || [])) {
    next();
    return;
  }
  next("/dashboard");
};

const TELAS_FOLHA_CALCULO = [
  [
    "folhas",
    "FolhaCalculoFolhas",
    "ListagemFolhaCalculo",
    [
      "ROLE_FolhaCalculo_List",
      "ROLE_FolhaFerias_List",
      "ROLE_FolhaFerias_Calcular",
      "ROLE_FolhaRescisao_List",
      "ROLE_FolhaRescisao_Calcular",
    ],
  ],
  [
    "configuracao",
    "FolhaCalculoConfiguracao",
    "ConfiguracaoFolha",
    ["ROLE_FolhaCalculo_List", "ROLE_FolhaConfiguracao_Update"],
  ],
  [
    "tabelas",
    "FolhaCalculoTabelas",
    "TabelasLegaisFolha",
    [
      "ROLE_FolhaTabelaLegal_List",
      "ROLE_FolhaTabelaLegal_Admin",
      "ROLE_FolhaCalculo_List",
    ],
  ],
];

// Telas do controle de compras por período: exige uma das permissões da rota.
const ifAuthenticatedComprasPeriodo = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next("login");
    return;
  }

  if (userHasAnyPermission(to.meta?.permissions || [])) {
    next();
    return;
  }

  next("/dashboard");
};

// Com a contagem do estoque ativa, o centro usa a tela de contagem no lugar da solicitação.
const ifAuthenticatedMinhaSolicitacaoCompras = (to, from, next) => {
  if (store.getters.isAuthenticated && contagemEstoqueAtiva(store.state)) {
    next({ path: "/dashboard/compras/minha-contagem", query: to.query });
    return;
  }
  ifAuthenticatedComprasPeriodo(to, from, next);
};

const ifAuthenticatedMinhaContagemEstoque = (to, from, next) => {
  if (store.getters.isAuthenticated && !contagemEstoqueAtiva(store.state)) {
    next({ path: "/dashboard/compras/minha-solicitacao", query: to.query });
    return;
  }
  ifAuthenticatedComprasPeriodo(to, from, next);
};

const ifAuthenticatedEntradasPendentesCaixaForte = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next("login");
    return;
  }

  if (userHasPermission("ROLE_CaixaForte_List")) {
    next();
    return;
  }

  next("/dashboard");
};

const ifAuthenticatedTutorialAdmin = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next("login");
    return;
  }

  if (
    userHasAnyPermission([
      "ROLE_Suporte_Atendimento",
      "ROLE_TutorialProcess_List",
      "ROLE_TutorialProcess_Insert",
      "ROLE_TutorialProcess_Update",
    ])
  ) {
    next();
    return;
  }

  next("/dashboard");
};

const ifAuthenticatedGeradoresRelatorios = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next("login");
    return;
  }

  if (userHasPermission("ROLE_GeradorRelatorio_List")) {
    next();
    return;
  }

  next("/dashboard");
};

const ifAuthenticatedExecucaoAvulsaGeradorRelatorio = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next("login");
    return;
  }

  if (userHasPermission("ROLE_GeradorRelatorio_Execute")) {
    next();
    return;
  }

  next("/dashboard");
};

const resolvePostoTrabalhoRondaDefaultPath = () => {
  if (userHasPermission("ROLE_PostoTrabalhoRondaLocal_List")) {
    return "/dashboard/postoTrabalhoRondaLocais";
  }
  if (userHasPermission("ROLE_PostoTrabalhoRondaPlanejamento_List")) {
    return "/dashboard/postoTrabalhoRondaPlanejamentos";
  }
  if (userHasPermission("ROLE_PostoTrabalhoRondaExecucao_List")) {
    return "/dashboard/postoTrabalhoRondaExecucoes";
  }
  return "/dashboard";
};

const routes = [
  {
    path: "/",
    component: PageLayout,
    children: [
      {
        path: "/",
        name: "Landing",
        component: () => import("@/views/Landing/Index"),
      },
      {
        path: "/pre-contratacao/:key",
        name: "PreContratacaoPublica",
        component: () =>
          import(
            "@/components/pessoal/funcionario-pre-contratacao/PreenchimentoFuncionarioPreContratracao.vue"
          ),
      },
      {
        path: "/documentacao-acessoria/revogar-assinatura/:hash",
        name: "FuncionarioDocumentacaoAcessoriaRevogacaoAssinaturaPublica",
        component: () =>
          import(
            "@/components/pessoal/funcionario-documentacao-acessoria/RevogacaoAssinaturaFuncionarioDocumentacaoAcessoria.vue"
          ),
        meta: {
          hideHeader: true,
          hideFooter: true,
          fullPage: true,
        },
      },
      {
        path: "/registro-ponto-web",
        name: "RegistroPontoWebPublico",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto-web/PublicRegistroPontoWeb.vue"
          ),
        meta: {
          hideFooter: true,
        },
      },
    ],
  },
  {
    path: "/",
    component: AuthIllustrationLayout,
    name: "Authentication Illustration",
    children: [
      {
        path: "/login",
        name: "Login",
        component: import("@/components/Login.vue"),
        beforeEnter: ifNotAuthenticated,
      },
      {
        path: "/recuperar-senha",
        name: "Esqueceu.senha",
        component: EsqueceuSenha,
        beforeEnter: ifNotAuthenticated,
      },
      {
        path: "/login_cliente",
        name: "LoginCliente",
        component: import("@/components/LoginPreserve.vue"),
        beforeEnter: ifNotAuthenticated,
      },
      {
        path: "/login_preserve",
        name: "LoginPreserve",
        redirect: (to) => ({
          name: "LoginCliente",
          query: {
            ...to.query,
            cliente: "preserve",
          },
          hash: to.hash,
        }),
      },
    ],
  },

  {
    path: "/",
    name: "Dashboard",
    component: DashboardLayout,
    children: [
      {
        path: "/dashboard/oportunidadesPublicas/fontes",
        name: "OportunidadeFontes",
        component: () => import("@/components/comercial/oportunidades/OportunidadeFontes.vue"),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "CLP", oportunidadeAcao: "Admin" },
      },
      {
        path: "/dashboard/oportunidadesPublicas/:id",
        name: "OportunidadeDetalhe",
        component: () => import("@/components/comercial/oportunidades/OportunidadeDetalhe.vue"),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "CLP" },
      },
      {
        path: "/dashboard/oportunidadesPublicas",
        name: "OportunidadesPublicas",
        component: () => import("@/components/comercial/oportunidades/OportunidadesPublicas.vue"),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "CLP" },
      },
      {
        path: "/dashboard",
        name: "Welcome",
        component: Dashboard,
        meta: {
          groupName: "Cajupe",
        },
      },
      {
        name: "MinhaFolhaPonto",
        path: "dashboard/minhaFolhaPonto",
        component: () =>
          import(
            "@/components/pessoal/documentos-pessoais/ConsultaDocumentoPessoal.vue"
          ),
        props: {
          documentType: "folhaPonto",
        },
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "MeuReciboPagamento",
        path: "dashboard/meuReciboPagamento",
        component: () =>
          import(
            "@/components/pessoal/documentos-pessoais/ConsultaDocumentoPessoal.vue"
          ),
        props: {
          documentType: "reciboPagamento",
        },
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "PortalUltimosRegistrosPonto",
        path: "dashboard/portal/ultimos-registros",
        component: () =>
          import(
            "@/components/pessoal/portal-trabalhador/PortalUltimosRegistrosPonto.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "PortalAusenciasPorIntervalo",
        path: "dashboard/portal/ausencias-por-intervalo",
        component: () =>
          import(
            "@/components/pessoal/portal-trabalhador/PortalAusenciasPorIntervalo.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "Pessoal" },
      },
      {
        name: "PortalSolicitacaoAfastamento",
        path: "dashboard/portal/solicitacao-afastamento",
        component: () =>
          import(
            "@/components/pessoal/portal-trabalhador/PortalSolicitacaoAfastamento.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "PortalSolicitacaoPonto",
        path: "dashboard/portal/solicitacao-ponto",
        component: () =>
          import(
            "@/components/pessoal/portal-trabalhador/PortalSolicitacaoPonto.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "PortalMeusDocumentosGed",
        path: "dashboard/portal/meus-documentos",
        component: () =>
          import("@/components/pessoal/portal-trabalhador/PortalMeusDocumentosGed.vue"),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "Pessoal" },
      },
      {
        name: "User Profile",
        path: "dashboard/pages/user",
        component: () => import("@/views/Dashboard/pages/UserProfile"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Cajupe",
        },
      },
      {
        name: "Notifications",
        path: "dashboard/components/notifications",
        component: () => import("@/views/Dashboard/component/Notifications"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Cajupe",
        },
      },
      {
        name: "Icons",
        path: "dashboard/components/icons",
        component: () => import("@/views/Dashboard/component/Icons"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Cajupe",
        },
      },
      {
        name: "Typography",
        path: "dashboard/components/typography",
        component: () => import("@/views/Dashboard/component/Typography"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Cajupe",
        },
      },
      // Tables
      {
        name: "Regular Tables",
        path: "dashboard/tables/regular-tables",
        component: () => import("@/views/Dashboard/tables/RegularTables"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Cajupe",
        },
      },
      // Maps
      {
        name: "Google Maps",
        path: "dashboard/maps/google-maps",
        component: () => import("@/views/Dashboard/maps/GoogleMaps"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Cajupe",
        },
      },
      // Upgrade
      {
        name: "Upgrade",
        path: "dashboard/upgrade",
        component: () => import("@/views/Dashboard/Upgrade"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Cajupe",
        },
      },
      {
        name: "clientes",
        path: "dashboard/clientes",
        component: () =>
          import("@/components/comercial/clientes/ListagemClientes"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },

      {
        name: "cadastro_cliente",
        path: "dashboard/clientes/cadastro",
        component: () =>
          import("@/components/comercial/clientes/CadastroCliente"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "editar.cliente",
        path: "dashboard/clientes/:id/editar",
        component: () =>
          import("@/components/comercial/clientes/EditarCliente"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "ClienteEnderecoClassificacoes",
        path: "dashboard/clienteEnderecoClassificacoes",
        component: () =>
          import(
            "@/components/comercial/cliente-endereco-classificacao/ListagemClienteEnderecoClassificacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "cadastro.ClienteEnderecoClassificacao",
        path: "dashboard/clienteEnderecoClassificacoes/cadastro",
        component: () =>
          import(
            "@/components/comercial/cliente-endereco-classificacao/CadastroClienteEnderecoClassificacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "editar.clienteenderecoclassificacao",
        path: "dashboard/clienteEnderecoClassificacoes/:id/editar",
        component: () =>
          import(
            "@/components/comercial/cliente-endereco-classificacao/EditarClienteEnderecoClassificacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "Usuário",
        path: "dashboard/usuario",
        component: PerfilUsuario,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Perfil ",
        },
      },
      {
        name: "cadastro.usuario",
        path: "dashboard/usuarios/cadastro",
        component: CadastroUsuario,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Acessos",
        },
      },
      {
        name: "Usuarios",
        path: "dashboard/usuarios",
        component: ListagemUsuarios,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Acessos",
        },
      },
      {
        name: "editar.usuario",
        path: "dashboard/usuarios/:id/editar",
        component: EditarUsuario,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Acessos",
        },
      },
      {
        name: "Pedidos",
        path: "dashboard/pedidos",
        component: ListagemPedidos,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "cadastro.pedido",
        path: "dashboard/pedidos/cadastro",
        component: () =>
          import("@/components/operacoes/pedidos/CadastroPedido"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "editar.pedido",
        path: "dashboard/pedidos/:id/editar",
        component: EditarPedido,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      // {
      //   name: "Uniformes",
      //   path: "dashboard/uniformes",
      //   component: ListagemFuncionarioUniforme,
      //   beforeEnter: ifAuthenticated
      // },
      // {
      //   name: "cadastro.uniforme",
      //   path: "dashboard/funcionariouniformes/cadastro",
      //   component: () =>
      //     import("@/components/pessoal/funcionario-uniforme/CadastroUniforme"),
      //   beforeEnter: ifAuthenticated
      // },
      // {
      //   name: "editar.funcionariouniforme",
      //   path: "dashboard/uniformes/:id/editar",
      //   component: EditarFuncionarioUniforme,
      //   beforeEnter: ifAuthenticated
      // },

      {
        name: "Inquilinos",
        path: "dashboard/inquilinos",
        component: ListagemInquilinos,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },
      {
        name: "GeradoresRelatorios",
        path: "dashboard/geradoresRelatorios",
        component: () =>
          import(
            "@/components/software/geradores-relatorios/ListagemGeradoresRelatorios.vue"
          ),
        beforeEnter: ifAuthenticatedGeradoresRelatorios,
        meta: {
          groupName: "GeradorRelatorio",
          permission: "ROLE_GeradorRelatorio_List",
        },
      },
      {
        name: "ExecucaoAvulsaGeradorRelatorio",
        path: "dashboard/geradoresRelatorios/executar",
        component: () =>
          import(
            "@/components/software/geradores-relatorios/ExecucaoAvulsaGeradorRelatorio.vue"
          ),
        beforeEnter: ifAuthenticatedExecucaoAvulsaGeradorRelatorio,
        meta: {
          groupName: "GeradorRelatorio",
          permission: "ROLE_GeradorRelatorio_Execute",
        },
      },
      {
        name: "Cadastro.inquilino",
        path: "dashboard/inquilinos/cadastro",
        component: CadastroInquilino,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },
      {
        name: "editar.inquilino",
        path: "dashboard/inquilinos/:id/editar",
        component: EditarInquilino,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },
      {
        name: "configuracoes.inquilino",
        path: "dashboard/inquilinos/configuracoes",
        component: () =>
          import("@/components/software/inquilinos/ConfiguracoesInquilino"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Configurações",
        },
      },
      {
        name: "FuncionarioSindicatos",
        path: "dashboard/funcionariosindicatos",
        component: ListagemFuncionarioSindicatos,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "Cadastro.FuncionarioSindicato",
        path: "dashboard/funcionariosindicatos/cadastro",
        component: CadastroFuncionarioSindicato,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "editar.funcionariosindicato",
        path: "dashboard/funcionariosindicatos/:id/editar",
        component: EditarFuncionarioSindicato,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "FuncionarioAfastamentoTipos",
        path: "dashboard/funcionarioAfastamentoTipos",
        component: ListagemFuncionarioAfastamentoTipos,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "cadastro.FuncionarioAfastamentoTipo",
        path: "dashboard/funcionarioAfastamentoTipos/cadastro",
        component: CadastroFuncionarioAfastamentoTipo,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "editar.funcionarioafastamentotipo",
        path: "dashboard/funcionarioAfastamentoTipos/:id/editar",
        component: EditarFuncionarioAfastamentoTipo,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "FuncionarioCargos",
        path: "dashboard/funcionariocargos",
        component: ListagemFuncionarioCargos,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "cadastro.funcionariocargo",
        path: "dashboard/funcionariocargos/cadastro",
        component: CadastroFuncionarioCargo,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "editar.funcionariocargo",
        path: "dashboard/funcionariocargos/:id/editar",
        component: EditarFuncionarioCargo,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "Medicos",
        path: "dashboard/medicos",
        component: () => import("@/components/pessoal/medicos/ListagemMedicos"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "cadastro.Medico",
        path: "dashboard/medicos/cadastro",
        component: () => import("@/components/pessoal/medicos/CadastroMedico"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "editar.medico",
        path: "dashboard/medicos/:id/editar",
        component: () => import("@/components/pessoal/medicos/EditarMedico"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "FuncionarioFolhaPagamentoVerbas",
        path: "dashboard/funcionarioFolhaPagamentoVerbas",
        component: ListagemFuncionarioFolhaPagamentoVerba,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "editar.funcionariofolhapagamentoverba",
        path: "dashboard/funcionariofolhapagamentoverba/:id/editar",
        component: EditarFuncionarioFolhaPagamentoVerba,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "Funcionarios",
        path: "dashboard/funcionarios",
        component: ListagemFuncionarios,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "FuncionarioContratacoesDesligamentosPeriodo",
        path: "dashboard/funcionarios/contratacoesDesligamentosPeriodo",
        component: () =>
          import(
            "@/components/pessoal/funcionarios/ListagemFuncionarioContratacoesDesligamentosPeriodo.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "RotatividadeAdmissionalDemissional",
        path: "dashboard/funcionarios/rotatividadeAdmissionalDemissional",
        component: () =>
          import(
            "@/components/pessoal/funcionarios/DashboardRotatividadeAdmissionalDemissional.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "IntegracaoExternaHistorico",
        path: "dashboard/integracoesExternas",
        component: () =>
          import(
            "@/components/software/integracoes-externas/ListagemIntegracaoExterna.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "Pessoal" },
      },
      {
        name: "FuncionarioIntegracaoExterna",
        path: "dashboard/funcionarios/integracaoExterna",
        component: () =>
          import(
            "@/components/pessoal/funcionarios/ListagemFuncionarioIntegracaoExterna.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "Cadastro.Funcionario",
        path: "dashboard/funcionarios/cadastro",
        component: () =>
          import("@/components/pessoal/funcionarios/CadastroFuncionario"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "Cadastro.FuncionarioResumed",
        path: "dashboard/funcionarios/cadastro/resume",
        component: () =>
          import(
            "@/components/pessoal/funcionarios-resume/CadastroFuncionarioResume"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "editar.funcionario",
        path: "dashboard/funcionarios/:id/editar",
        component: EditarFuncionario,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "QuadroFuncionarios",
        path: "dashboard/funcionarios/quadroFuncionarios",
        component: () =>
          import(
            "@/components/pessoal/funcionarios/DashboardQuadroFuncionarios"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "AnalisePeriodoExperiencia",
        path: "dashboard/funcionarios/periodoExperiencia",
        component: () =>
          import(
            "@/components/pessoal/funcionarios/AnalisePeriodoExperiencia.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "AnaliseValidadeCursos",
        path: "dashboard/funcionarios/validadeCursos",
        component: () =>
          import("@/components/pessoal/funcionarios/AnaliseValidadeCursos.vue"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "AnaliseDesligamentos",
        path: "dashboard/funcionarios/desligamentos",
        component: () =>
          import("@/components/pessoal/funcionarios/AnaliseDesligamentos.vue"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "FuncionarioPontos",
        path: "dashboard/funcionariopontos",
        component: ListagemFuncionarioPontos,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "DashboardFuncionarioPonto",
        path: "dashboard/funcionariopontos/dashboard",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/graficos/registro-ponto/DashboardFuncionarioPonto.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "DashboardCercaPerimetroFuncionarioPonto",
        path: "dashboard/funcionariopontos/cerca-perimetro",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/graficos/registro-ponto/DashboardCercaPerimetroFuncionarioPonto.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "Cadastro.FuncionarioPonto",
        path: "dashboard/funcionariopontos/cadastro",
        component: CadastroFuncionarioPonto,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "editar.funcionarioponto",
        path: "dashboard/funcionariopontos/:id/editar",
        component: EditarFuncionarioPonto,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "Paises",
        path: "dashboard/paises",
        component: ListagemPaises,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Locais",
        },
      },
      {
        name: "Cadastro.Pais",
        path: "dashboard/paises/cadastro",
        component: CadastroPais,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Locais",
        },
      },
      {
        name: "editar.pais",
        path: "dashboard/paises/:id/editar",
        component: EditarPais,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Locais",
        },
      },
      {
        name: "Pessoas",
        path: "dashboard/pessoas",
        component: () => import("@/components/pessoal/pessoas/ListagemPessoas"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "Cadastro.Pessoa",
        path: "dashboard/pessoas/cadastro",
        component: () => import("@/components/pessoal/pessoas/CadastroPessoa"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "editar.pessoa",
        path: "dashboard/pessoas/:id/editar",
        component: () => import("@/components/pessoal/pessoas/EditarPessoa"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "Estados",
        path: "dashboard/estados",
        component: () => import("@/components/locais/estados/ListagemEstados"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Locais",
        },
      },
      {
        name: "Cadastro.estado",
        path: "dashboard/estados/cadastro",
        component: () => import("@/components/locais/estados/CadastroEstado"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Locais",
        },
      },
      {
        name: "editar.estado",
        path: "dashboard/estados/:id/editar",
        component: () => import("@/components/locais/estados/EditarEstado"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Locais",
        },
      },
      {
        name: "Cidades",
        path: "dashboard/cidades",
        component: () => import("@/components/locais/cidades/ListagemCidades"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Locais",
        },
      },
      {
        name: "Cadastro.cidade",
        path: "dashboard/cidades/cadastro",
        component: () => import("@/components/locais/cidades/CadastroCidade"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Locais",
        },
      },
      {
        name: "editar.cidade",
        path: "dashboard/cidades/:id/editar",
        component: () => import("@/components/locais/cidades/EditarCidade"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Locais",
        },
      },
      {
        name: "Veiculos",
        path: "dashboard/veiculos",
        component: () =>
          import("@/components/operacoes/veiculos/ListagemVeiculos"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "cadastro.veiculos",
        path: "dashboard/veiculos/cadastro",
        component: () =>
          import("@/components/operacoes/veiculos/CadastroVeiculo"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "editar.veiculo",
        path: "dashboard/veiculos/:id/editar",
        component: () =>
          import("@/components/operacoes/veiculos/EditarVeiculo"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "VeiculoModelos",
        path: "dashboard/veiculoModelos",
        component: () =>
          import(
            "@/components/operacoes/veiculo-modelos/ListagemVeiculoModelos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "cadastro.VeiculoModelos",
        path: "dashboard/veiculoModelos/cadastro",
        component: () =>
          import(
            "@/components/operacoes/veiculo-modelos/CadastroVeiculoModelo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "editar.veiculomodelo",
        path: "dashboard/veiculoModelos/:id/editar",
        component: () =>
          import("@/components/operacoes/veiculo-modelos/EditarVeiculoModelo"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "Roteiros",
        path: "dashboard/roteiros",
        component: () =>
          import("@/components/operacoes/roteiros/ListagemRoteiros"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "cadastro.roteiro",
        path: "dashboard/roteiros/cadastro",
        component: () =>
          import("@/components/operacoes/roteiros/CadastroRoteiro"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "editar.roteiro",
        path: "dashboard/roteiros/:id/editar",
        component: () =>
          import("@/components/operacoes/roteiros/EditarRoteiro"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "RoteiroModelos",
        path: "dashboard/roteiroModelos",
        component: () =>
          import("@/components/operacoes/roteiroModelos/ListagemRoteiroModelo"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "cadastro.roteiroModelos",
        path: "dashboard/roteiroModelos/cadastro",
        component: () =>
          import("@/components/operacoes/roteiroModelos/CadastroRoteiroModelo"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "editar.roteiromodelo",
        path: "dashboard/roteiroModelos/:id/editar",
        component: () =>
          import("@/components/operacoes/roteiroModelos/EditarRoteiroModelo"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "AcompanhamentoTrajetos",
        path: "dashboard/acompanhamento/trajetos",
        component: () =>
          import(
            "@/components/operacoes/roteiroTrajeto/ListagemRoteiroTrajeto"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "GuiaTransporte",
        path: "dashboard/guiaTransportes",
        component: () =>
          import(
            "@/components/operacoes/guiaTransporte/ListagemGuiaTransporte"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "Suprimentos",
        path: "dashboard/suprimentos",
        component: () => import("@/components/operacoes/tesouraria/Suprimento"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "cadastro.suprimento",
        path: "dashboard/suprimentos/cadastro",
        component: () =>
          import("@/components/operacoes/tesouraria/CadastroSuprimento"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "editar.suprimento",
        path: "dashboard/suprimentos/:id/editar",
        component: () =>
          import("@/components/operacoes/tesouraria/EditarSuprimento"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "Questionarios",
        path: "dashboard/questionarios",
        component: () =>
          import("@/components/operacoes/questionarios/ListagemQuestionarios"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "SPT",
        },
      },
      {
        name: "cadastro.questionario",
        path: "dashboard/questionarios/cadastro",
        component: () =>
          import("@/components/operacoes/questionarios/CadastroQuestionario"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "SPT",
        },
      },
      {
        name: "editar.questionario",
        path: "dashboard/questionarios/:id/editar",
        component: () =>
          import("@/components/operacoes/questionarios/EditarQuestionario"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "SPT",
        },
      },
      {
        name: "PostoTrabalhoSupervisoes",
        path: "dashboard/postoTrabalhoSupervisoes",
        component: () =>
          import(
            "@/components/operacoes/posto-trabalho-supervisao/ListagemPostoTrabalhoSupervisao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "SPT",
        },
      },
      {
        name: "PostoTrabalhoRondas",
        path: "dashboard/postoTrabalhoRondas",
        beforeEnter: (to, from, next) => {
          if (!store.getters.isAuthenticated) {
            next("login");
            return;
          }
          next(resolvePostoTrabalhoRondaDefaultPath());
        },
        meta: {
          groupName: "RPT",
        },
      },
      {
        name: "PostoTrabalhoRondaLocais",
        path: "dashboard/postoTrabalhoRondaLocais",
        component: () =>
          import(
            "@/components/operacoes/posto-trabalho-ronda/ListagemPostoTrabalhoRondaLocais"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "RPT",
        },
      },
      {
        name: "PostoTrabalhoRondaPlanejamentos",
        path: "dashboard/postoTrabalhoRondaPlanejamentos",
        component: () =>
          import(
            "@/components/operacoes/posto-trabalho-ronda/ListagemPostoTrabalhoRondaPlanejamentos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "RPT",
        },
      },
      {
        name: "PostoTrabalhoRondaExecucoes",
        path: "dashboard/postoTrabalhoRondaExecucoes",
        component: () =>
          import(
            "@/components/operacoes/posto-trabalho-ronda/ListagemPostoTrabalhoRondaExecucoes"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "RPT",
        },
      },
      {
        name: "Nr1Topicos",
        path: "dashboard/nr1Topicos",
        component: () =>
          import("@/components/pessoal/nr1/nr1-topicos/ListagemNr1Topicos"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "NR1",
        },
      },
      {
        name: "cadastro.nr1topico",
        path: "dashboard/nr1Topicos/cadastro",
        component: () =>
          import("@/components/pessoal/nr1/nr1-topicos/CadastroNr1Topico"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "NR1",
        },
      },
      {
        name: "editar.nr1topico",
        path: "dashboard/nr1Topicos/:id/editar",
        component: () =>
          import("@/components/pessoal/nr1/nr1-topicos/EditarNr1Topico"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "NR1",
        },
      },
      {
        name: "Nr1Campanhas",
        path: "dashboard/nr1Campanhas",
        component: () =>
          import("@/components/pessoal/nr1/nr1-campanhas/ListagemNr1Campanhas"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "NR1",
        },
      },
      {
        name: "cadastro.nr1campanha",
        path: "dashboard/nr1Campanhas/cadastro",
        component: () =>
          import("@/components/pessoal/nr1/nr1-campanhas/CadastroNr1Campanha"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "NR1",
        },
      },
      {
        name: "editar.nr1campanha",
        path: "dashboard/nr1Campanhas/:id/editar",
        component: () =>
          import("@/components/pessoal/nr1/nr1-campanhas/EditarNr1Campanha"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "NR1",
        },
      },
      {
        name: "Nr1CampanhasDashboard",
        path: "dashboard/nr1Campanhas/dashboard",
        component: () =>
          import(
            "@/components/pessoal/nr1/nr1-campanhas/DashboardNr1Campanhas"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "NR1",
        },
      },
      {
        name: "Nr1CampanhasDashboardGraficos",
        path: "dashboard/nr1Campanhas/dashboard-graficos",
        component: () =>
          import(
            "@/components/pessoal/nr1/nr1-campanhas/DashboardNr1CampanhasGraficos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "NR1",
        },
      },
      {
        name: "Produtos",
        path: "dashboard/produtos",
        component: () =>
          import("@/components/recursos/produtos/ListagemProdutos"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "Inventario",
        path: "dashboard/inventario",
        component: () => import("@/components/recursos/inventario/Inventario"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "MeuInventario",
        path: "dashboard/meu-inventario",
        component: () =>
          import("@/components/recursos/inventario/MeuInventario"),
        beforeEnter: ifAuthenticatedMeuInventario,
        meta: {
          groupName: "Recursos",
          permission: "ROLE_ProdutoCentroEstoque_Inventario",
        },
      },
      {
        name: "cadastro.produto",
        path: "dashboard/produtos/cadastro",
        component: () =>
          import("@/components/recursos/produtos/CadastroProduto"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "editar.produto",
        path: "dashboard/produtos/:id/editar",
        component: () => import("@/components/recursos/produtos/EditarProduto"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "ProdutoCategorias",
        path: "dashboard/produtoCategorias",
        component: () =>
          import(
            "@/components/recursos/produto-categorias/ListagemProdutoCategorias"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "cadastro.produtoCategoria",
        path: "dashboard/produtoCategorias/cadastro",
        component: () =>
          import(
            "@/components/recursos/produto-categorias/CadastroProdutoCategoria"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Cajupe",
        },
      },
      {
        name: "editar.produtoCategoria",
        path: "dashboard/produtoCategorias/:id/editar",
        component: () =>
          import(
            "@/components/recursos/produto-categorias/EditarProdutoCategoria"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Cajupe",
        },
      },
      {
        name: "ContaBancarias",
        path: "dashboard/contaBancarias",
        component: () =>
          import(
            "@/components/financeiro/conta-bancarias/ListagemContaBancarias"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "cadastro.contaBancaria",
        path: "dashboard/contaBancarias/cadastro",
        component: () =>
          import(
            "@/components/financeiro/conta-bancarias/CadastroContaBancaria"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "editar.contabancaria",
        path: "dashboard/contaBancarias/:id/editar",
        component: () =>
          import("@/components/financeiro/conta-bancarias/EditarContaBancaria"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "extrato.contabancaria",
        path: "dashboard/contaBancarias/extrato",
        component: () =>
          import("@/components/financeiro/conta-bancarias/Extrato"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },

      {
        name: "fluxoDiario",
        path: "dashboard/financeiro/fluxoDiario",
        component: () => import("@/components/financeiro/analises/FluxoDiario"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },

      {
        name: "dfc.direto",
        path: "dashboard/financeiro/dfc/direto",
        component: () => import("@/components/financeiro/analises/dfc/DFC"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },

      {
        name: "analiseCC",
        path: "dashboard/financeiro/analiseCC/analise",
        component: () =>
          import("@/components/financeiro/analises/analiseCC/Analise"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },

      {
        name: "DRE",
        path: "dashboard/financeiro/analises/dre",
        component: () => import("@/components/financeiro/analises/dre/DRE"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },

      {
        name: "CentroCustos",
        path: "dashboard/centroCustos",
        component: () =>
          import("@/components/financeiro/centro-custos/ListagemCentroCustos"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "CentroCustosAnalitico",
        path: "dashboard/centroCustosAnalitico",
        component: () =>
          import(
            "@/components/financeiro/centro-custos/ListagemCentroCustosAnalitico"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "CentroCustoNiveis",
        path: "dashboard/centroCustoNiveis",
        component: () =>
          import(
            "@/components/financeiro/centro-custo-nivel/ListagemCentroCustoNivel"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },

      {
        name: "RateioCentroCustoPadroes",
        path: "dashboard/rateioCentroCustoPadroes",
        component: () =>
          import(
            "@/components/financeiro/rateio-centro-custo-padrao/ListagemRateioCentroCustoPadroes"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "cadastro.rateioCentroCustoPadrao",
        path: "dashboard/rateioCentroCustoPadroes/cadastro",
        component: () =>
          import(
            "@/components/financeiro/rateio-centro-custo-padrao/CadastroRateioCentroCustoPadrao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "editar.rateiocentrocustopadrao",
        path: "dashboard/rateioCentroCustoPadroes/:id/editar",
        component: () =>
          import(
            "@/components/financeiro/rateio-centro-custo-padrao/EditarRateioCentroCustoPadrao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "cadastro.centroCusto",
        path: "dashboard/centroCustos/cadastro",
        component: () =>
          import("@/components/financeiro/centro-custos/CadastroCentroCusto"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "editar.centrocusto",
        path: "dashboard/centroCustos/:id/editar",
        component: () =>
          import("@/components/financeiro/centro-custos/EditarCentroCusto"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "cadastro.centroCustoNivel",
        path: "dashboard/centroCustoNiveis/cadastro",
        component: () =>
          import(
            "@/components/financeiro/centro-custo-nivel/CadastroCentroCustoNivel"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "editar.centrocustonivel",
        path: "dashboard/centroCustoNiveis/:id/editar",
        component: () =>
          import(
            "@/components/financeiro/centro-custo-nivel/EditarCentroCustoNivel"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },

      {
        name: "OrcamentoAnual",
        path: "dashboard/orcamentosAnuais",
        component: () =>
          import(
            "@/components/financeiro/orcamento-anual/ListagemOrcamentoAnual"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },

      {
        name: "ContaBancariaTransferencias",
        path: "dashboard/contaBancariaTransferencias",
        component: () =>
          import(
            "@/components/financeiro/conta-bancaria-transferencia/ListagemContaBancariaTransferencia"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },

      {
        name: "cadastro.ContaBancariaTransferencia",
        path: "dashboard/contaBancariaTransferencias/cadastro",
        component: () =>
          import(
            "@/components/financeiro/conta-bancaria-transferencia/CadastroContaBancariaTransferencia"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "editar.contabancariatransferencia",
        path: "dashboard/contaBancariaTransferencias/:id/editar",
        component: () =>
          import(
            "@/components/financeiro/conta-bancaria-transferencia/EditarContaBancariaTransferencia"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },

      {
        name: "Fornecedores",
        path: "dashboard/fornecedores",
        component: () =>
          import("@/components/financeiro/fornecedores/ListagemFornecedores"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "cadastro.fornecedor",
        path: "dashboard/fornecedores/cadastro",
        component: () =>
          import("@/components/financeiro/fornecedores/CadastroFornecedor"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "editar.fornecedor",
        path: "dashboard/fornecedores/:id/editar",
        component: () =>
          import("@/components/financeiro/fornecedores/EditarFornecedor"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },

      {
        name: "TituloReceber",
        path: "dashboard/tituloReceber",
        component: () =>
          import(
            "@/components/financeiro/titulo-receber/ListagemTituloReceber"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "LancamentosFinanceiros",
        path: "dashboard/financeiro/lancamentos",
        component: () =>
          import(
            "@/components/financeiro/lancamento-financeiro/CentralLancamentosFinanceiros"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "CentralCobrancas",
        path: "dashboard/financeiro/cobrancas",
        component: () =>
          import("@/components/financeiro/cobrancas/CentralCobrancas"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "TituloReceberPending",
        path: "dashboard/tituloReceberPending",
        component: () =>
          import(
            "@/components/financeiro/titulo-receber/ListagemTituloReceberPending"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "cadastro.tituloReceber",
        path: "dashboard/tituloreceber/cadastro",
        component: () =>
          import(
            "@/components/financeiro/titulo-receber/CadastroTituloReceber"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "editar.tituloreceber",
        path: "dashboard/tituloreceber/:id/editar",
        component: () =>
          import("@/components/financeiro/titulo-receber/EditarTituloReceber"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },

      {
        name: "RegistroRecebimentos",
        path: "dashboard/registroRecebimentos",
        component: () =>
          import(
            "@/components/financeiro/registro-recebimentos/ListagemRegistroRecebimentos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "cadastro.registroRecebimentos",
        path: "dashboard/registroRecebimentos/cadastro",
        component: () =>
          import(
            "@/components/financeiro/registro-recebimentos/CadastroRegistroRecebimento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "editar.registrorecebimento",
        path: "dashboard/registroRecebimentos/:id/editar",
        component: () =>
          import(
            "@/components/financeiro/registro-recebimentos/EditarRegistroRecebimento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },

      {
        name: "TituloPagar",
        path: "dashboard/tituloPagar",
        component: () =>
          import("@/components/financeiro/titulo-pagar/ListagemTituloPagar"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "TituloPagarPending",
        path: "dashboard/tituloPagarPending",
        component: () =>
          import(
            "@/components/financeiro/titulo-pagar/ListagemTituloPagarPending"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "cadastro.tituloPagar",
        path: "dashboard/tituloPagar/cadastro",
        component: () =>
          import("@/components/financeiro/titulo-pagar/CadastroTituloPagar"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "editar.titulopagar",
        path: "dashboard/tituloPagar/:id/editar",
        component: () =>
          import("@/components/financeiro/titulo-pagar/EditarTituloPagar"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },

      {
        name: "RegistroPagamentos",
        path: "dashboard/registroPagamentos",
        component: () =>
          import(
            "@/components/financeiro/registro-pagamentos/ListagemRegistroPagamentos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "cadastro.registroPagamentos",
        path: "dashboard/registroPagamentos/cadastro",
        component: () =>
          import(
            "@/components/financeiro/registro-pagamentos/CadastroRegistroPagamento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "editar.registropagamento",
        path: "dashboard/registroPagamentos/:id/editar",
        component: () =>
          import(
            "@/components/financeiro/registro-pagamentos/EditarRegistroPagamento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "FinanceiroPeriodo",
        path: "dashboard/financeiroPeriodos",
        component: () =>
          import(
            "@/components/financeiro/financeiro-periodo/ListagemFinanceiroPeriodos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "cadastro.FinanceiroPeriodo",
        path: "dashboard/financeiroPeriodos/cadastro",
        component: () =>
          import(
            "@/components/financeiro/financeiro-periodo/CadastroFinanceiroPeriodo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "editar.financeiroperiodo",
        path: "dashboard/financeiroPeriodos/:id/editar",
        component: () =>
          import(
            "@/components/financeiro/financeiro-periodo/EditarFinanceiroPeriodo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },

      {
        name: "FuncionarioPontoCalculo",
        path: "dashboard/funcionarioPontoCalculos",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/ListagemFuncionarioPontoCalculo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "PessoalGestaoComunicacoes",
        path: "dashboard/pessoalGestaoComunicacoes",
        component: () => import("@/components/pessoal/gestao-comunicacoes/PessoalGestaoComunicacoes.vue"),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "Ponto-RRP" },
      },
      {
        name: "FuncionarioPontoPeriodo",
        path: "dashboard/funcionarioPontoPeriodos",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo/ListagemFuncionarioPontoPeriodos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "TutorialFuncionarioPontoPeriodo",
        path: "dashboard/tutorial/funcionarioPontoPeriodos",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo/TutorialListagemFuncionarioPontoPeriodos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "cadastro.funcionarioPontoPeriodo",
        path: "dashboard/funcionarioPontoPeriodos/cadastro",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo/CadastroFuncionarioPontoPeriodo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "editar.funcionariopontoperiodo",
        path: "dashboard/funcionarioPontoPeriodos/:id/editar",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo/EditarFuncionarioPontoPeriodo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "tutorial.editar.funcionariopontoperiodo",
        path: "dashboard/tutorial/funcionarioPontoPeriodos/:id/editar",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo/TutorialEditarFuncionarioPontoPeriodo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "FuncionarioPontoPeriodoReducaoCargaHorariaColetiva",
        path: "dashboard/funcionarioPontoPeriodoReducaoCargaHorariaColetiva",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo-reducao-carga-horaria-coletiva/ListagemFuncionarioPontoPeriodoReducaoCargaHorariaColetiva"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "cadastro.funcionarioPontoPeriodoReducaoCargaHorariaColetiva",
        path: "dashboard/funcionarioPontoPeriodoReducaoCargaHorariaColetivas/cadastro",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo-reducao-carga-horaria-coletiva/CadastroFuncionarioPontoPeriodoReducaoCargaHorariaColetiva"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "editar.funcionariopontoperiodoreducaocargahorariacoletiva",
        path: "dashboard/funcionarioPontoPeriodoReducaoCargaHorariaColetivas/:id/editar",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo-reducao-carga-horaria-coletiva/EditarFuncionarioPontoPeriodoReducaoCargaHorariaColetiva"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "FolgaBonusRegras",
        path: "dashboard/folgaBonusRegras",
        component: () =>
          import("@/components/pessoal/folga-bonus/ListagemFolgaBonusRegras"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "cadastro.FolgaBonusRegra",
        path: "dashboard/folgaBonusRegras/cadastro",
        component: () =>
          import("@/components/pessoal/folga-bonus/CadastroFolgaBonusRegra"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "editar.folgabonusregra",
        path: "dashboard/folgaBonusRegras/:id/editar",
        component: () =>
          import("@/components/pessoal/folga-bonus/EditarFolgaBonusRegra"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "FolgaBonusApuracao",
        path: "dashboard/folgaBonusApuracao",
        component: () =>
          import("@/components/pessoal/folga-bonus/ApuracaoFolgaBonus"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "FuncionarioPontoNotificacoes",
        path: "dashboard/funcionarioPontoNotificacoes",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/funcionario-ponto-notificacao/ListagemFuncionarioPontoNotificacoes"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "cadastro.FuncionarioPontoNotificacao",
        path: "dashboard/funcionarioPontoNotificacoes/cadastro",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/funcionario-ponto-notificacao/CadastroFuncionarioPontoNotificacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "editar.funcionariopontonotificacao",
        path: "dashboard/funcionarioPontoNotificacoes/:id/editar",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/funcionario-ponto-notificacao/EditarFuncionarioPontoNotificacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "ParametrizacaoFiscal",
        path: "dashboard/parametrizacaoFiscal",
        component: () =>
          import(
            "@/components/comercial/parametrizacao-fiscal/ListagemParametrizacaoFiscal"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "cadastro.parametrizacaoFiscal",
        path: "dashboard/parametrizacaoFiscal/cadastro",
        component: () =>
          import(
            "@/components/comercial/parametrizacao-fiscal/CadastroParametrizacaoFiscal"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "editar.parametrizacaofiscal",
        path: "dashboard/parametrizacaoFiscal/:id/editar",
        component: () =>
          import(
            "@/components/comercial/parametrizacao-fiscal/EditarParametrizacaoFiscal"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },

      {
        name: "Contratos",
        path: "dashboard/contratos",
        component: () =>
          import("@/components/comercial/contratos/ListagemContratos"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "PropostaComerciais",
        path: "dashboard/propostaComercial",
        component: () =>
          import(
            "@/components/comercial/proposta-comercial/ListagemPropostaComercial"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAP",
        },
      },
      {
        name: "DashboardPropostaComercial",
        path: "dashboard/propostaComercial/painel",
        component: () =>
          import(
            "@/components/comercial/proposta-comercial/DashboardPropostaComercial"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAP",
        },
      },
      {
        name: "cadastro.propostaComercial",
        path: "dashboard/propostaComercial/cadastro",
        component: () =>
          import(
            "@/components/comercial/proposta-comercial/CadastroPropostaComercial"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAP",
        },
      },
      {
        name: "editar.propostacomercial",
        path: "dashboard/propostaComercial/:id/editar",
        component: () =>
          import(
            "@/components/comercial/proposta-comercial/EditarPropostaComercial"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAP",
        },
      },
      {
        name: "ModeloPropostaComerciais",
        path: "dashboard/modeloPropostaComercial",
        component: () =>
          import(
            "@/components/comercial/modelo-proposta-comercial/ListagemModeloPropostaComercial"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAP",
        },
      },
      {
        name: "cadastro.modeloPropostaComercial",
        path: "dashboard/modeloPropostaComercial/cadastro",
        component: () =>
          import(
            "@/components/comercial/modelo-proposta-comercial/CadastroModeloPropostaComercial"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAP",
        },
      },
      {
        name: "editar.modelopropostacomercial",
        path: "dashboard/modeloPropostaComercial/:id/editar",
        component: () =>
          import(
            "@/components/comercial/modelo-proposta-comercial/EditarModeloPropostaComercial"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAP",
        },
      },
      {
        name: "D4SignConfiguracao",
        path: "dashboard/d4signConfiguracao",
        component: () =>
          import(
            "@/components/comercial/d4sign-configuracao/D4SignConfiguracao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAP",
        },
      },

      {
        name: "RotinasInternas",
        path: "dashboard/rotinasInternas",
        component: () =>
          import(
            "@/components/pessoal/rotinas-internas/RotinasInternasPagina.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "CLP",
          permissao: "ROLE_RotinaInterna_List",
        },
      },
      {
        name: "Certidoes",
        path: "dashboard/certidoes",
        component: () =>
          import("@/components/comercial/certidoes/ListagemCertidoes"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "CLP",
          modulo: "GESTAOCERTIDOES",
        },
      },
      {
        name: "cadastro.Certidao",
        path: "dashboard/certidoes/cadastro",
        component: () =>
          import("@/components/comercial/certidoes/CadastroCertidao"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "CLP",
          modulo: "GESTAOCERTIDOES",
        },
      },
      {
        name: "editar.certidao",
        path: "dashboard/certidoes/:id/editar",
        component: () =>
          import("@/components/comercial/certidoes/EditarCertidao"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "CLP",
          modulo: "GESTAOCERTIDOES",
        },
      },
      {
        name: "ReajustesContratuais",
        path: "dashboard/reajustesContratuais",
        component: () =>
          import(
            "@/components/comercial/reajusteContratual/ListagemReajusteContratual"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "cadastro.contratos",
        path: "dashboard/contratos/cadastro",
        component: () =>
          import("@/components/comercial/contratos/CadastroContrato"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "editar.contrato",
        path: "dashboard/contratos/:id/editar",
        component: () =>
          import("@/components/comercial/contratos/EditarContrato"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },

      {
        name: "ConcomitanciasTransporte",
        path: "dashboard/concomitanciasTransporte",
        component: () =>
          import(
            "@/components/comercial/concomitancia-transporte/ListagemConcomitanciasTransporte"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "Comercial" },
      },
      {
        name: "cadastro.concomitanciasTransporte",
        path: "dashboard/concomitanciasTransporte/cadastro",
        component: () =>
          import(
            "@/components/comercial/concomitancia-transporte/CadastroConcomitanciaTransporte"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "Comercial" },
      },
      {
        name: "editar.concomitanciatransporte",
        path: "dashboard/concomitanciasTransporte/:id/editar",
        component: () =>
          import(
            "@/components/comercial/concomitancia-transporte/EditarConcomitanciaTransporte"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "Comercial" },
      },

      {
        name: "EscopoServicos",
        path: "dashboard/escopoServicos",
        component: () =>
          import(
            "@/components/comercial/escopo-servicos/ListagemEscopoServicos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "cadastro.escopoServicos",
        path: "dashboard/escopoServicos/cadastro",
        component: () =>
          import(
            "@/components/comercial/escopo-servicos/CadastroEscopoServico"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "editar.escoposervico",
        path: "dashboard/escopoServicos/:id/editar",
        component: () =>
          import("@/components/comercial/escopo-servicos/EditarEscopoServico"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },

      {
        name: "ParametrizacaoServicos",
        path: "dashboard/parametrizacaoServicos",
        component: () =>
          import(
            "@/components/comercial/parametrizacao-servicos/ListagemParametrizacaoServicos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "cadastro.parametrizacaoServicos",
        path: "dashboard/parametrizacaoServicos/cadastro",
        component: () =>
          import(
            "@/components/comercial/parametrizacao-servicos/CadastroParametrizacaoServico"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "editar.parametrizacaoservico",
        path: "dashboard/parametrizacaoServicos/:id/editar",
        component: () =>
          import(
            "@/components/comercial/parametrizacao-servicos/EditarParametrizacaoServico"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },

      {
        name: "PostoTrabalhos",
        path: "dashboard/postoTrabalhos",
        component: () =>
          import(
            "@/components/comercial/posto-trabalho/ListagemPostoTrabalhos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "cadastro.postoTrabalhos",
        path: "dashboard/postoTrabalhos/cadastro",
        component: () =>
          import("@/components/comercial/posto-trabalho/CadastroPostoTrabalho"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "editar.postotrabalho",
        path: "dashboard/postoTrabalhos/:id/editar",
        component: () =>
          import("@/components/comercial/posto-trabalho/EditarPostoTrabalho"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },

      {
        name: "FuncionarioEscalaTrabalhos",
        path: "dashboard/funcionarioEscalaTrabalhos",
        component: () =>
          import(
            "@/components/pessoal/funcionario-escala-trabalho/ListagemFuncionarioEscalaTrabalhos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "cadastro.funcionarioEscalaTrabalhos",
        path: "dashboard/funcionarioEscalaTrabalhos/cadastro",
        component: () =>
          import(
            "@/components/pessoal/funcionario-escala-trabalho/CadastroFuncionarioEscalaTrabalho"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "editar.funcionarioescalatrabalho",
        path: "dashboard/funcionarioEscalaTrabalhos/:id/editar",
        component: () =>
          import(
            "@/components/pessoal/funcionario-escala-trabalho/EditarFuncionarioEscalaTrabalho"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "ArmaFogos",
        path: "dashboard/armaFogos",
        component: () =>
          import("@/components/operacoes/arma-fogo/ListagemArmaFogos"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAC",
        },
      },
      {
        name: "ArmaFogoAuditoria",
        path: "dashboard/armaFogoAuditoria",
        component: () =>
          import("@/components/operacoes/arma-fogo/ListagemArmaFogoAuditoria"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAC",
        },
      },
      {
        name: "ArmaFogoManutencoes",
        path: "dashboard/armaFogoManutencoes",
        component: () =>
          import(
            "@/components/operacoes/arma-fogo/ListagemArmaFogoManutencoes"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAC",
        },
      },
      {
        name: "cadastro.ArmaFogo",
        path: "dashboard/armaFogos/cadastro",
        component: () =>
          import("@/components/operacoes/arma-fogo/CadastroArmaFogo"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAC",
        },
      },
      {
        name: "cadastro.ArmaFogoManutencao",
        path: "dashboard/armaFogoManutencoes/cadastro",
        component: () =>
          import("@/components/operacoes/arma-fogo/CadastroArmaFogoManutencao"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAC",
        },
      },
      {
        name: "editar.armafogomanutencao",
        path: "dashboard/armaFogoManutencoes/:id/editar",
        component: () =>
          import("@/components/operacoes/arma-fogo/EditarArmaFogoManutencao"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAC",
        },
      },
      {
        name: "editar.armafogo",
        path: "dashboard/armaFogos/:id/editar",
        component: () =>
          import("@/components/operacoes/arma-fogo/EditarArmaFogo"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAC",
        },
      },
      {
        name: "ArmaFogoMunicoes",
        path: "dashboard/armaFogoMunicoes",
        component: () =>
          import(
            "@/components/operacoes/arma-fogo-municao/ListagemArmaFogoMunicoes"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GAC" },
      },
      {
        name: "cadastro.ArmaFogoMunicao",
        path: "dashboard/armaFogoMunicoes/cadastro",
        component: () =>
          import(
            "@/components/operacoes/arma-fogo-municao/CadastroArmaFogoMunicao"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GAC" },
      },
      {
        name: "editar.armafogomunicao",
        path: "dashboard/armaFogoMunicoes/:id/editar",
        component: () =>
          import(
            "@/components/operacoes/arma-fogo-municao/EditarArmaFogoMunicao"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GAC" },
      },
      {
        name: "ArmaFogoMunicaoMovimentacoes",
        path: "dashboard/armaFogoMunicaoMovimentacoes",
        component: () =>
          import(
            "@/components/operacoes/arma-fogo-municao/ListagemArmaFogoMunicaoMovimentacoes"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GAC" },
      },
      {
        name: "cadastro.ArmaFogoMunicaoMovimentacao",
        path: "dashboard/armaFogoMunicaoMovimentacoes/cadastro",
        component: () =>
          import(
            "@/components/operacoes/arma-fogo-municao/CadastroArmaFogoMunicaoMovimentacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GAC" },
      },
      {
        name: "editar.armafogomunicaomovimentacao",
        path: "dashboard/armaFogoMunicaoMovimentacoes/:id/editar",
        component: () =>
          import(
            "@/components/operacoes/arma-fogo-municao/EditarArmaFogoMunicaoMovimentacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GAC" },
      },
      {
        name: "ColeteBalisticos",
        path: "dashboard/coleteBalisticos",
        component: () =>
          import(
            "@/components/operacoes/colete-balistico/ListagemColeteBalisticos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAC",
        },
      },
      {
        name: "cadastro.ColeteBalistico",
        path: "dashboard/coleteBalisticos/cadastro",
        component: () =>
          import(
            "@/components/operacoes/colete-balistico/CadastroColeteBalistico"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAC",
        },
      },
      {
        name: "editar.coletebalistico",
        path: "dashboard/coleteBalisticos/:id/editar",
        component: () =>
          import(
            "@/components/operacoes/colete-balistico/EditarColeteBalistico"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAC",
        },
      },

      {
        name: "FuncionarioMovimentacoes",
        path: "dashboard/funcionarioMovimentacoes",
        component: () =>
          import(
            "@/components/pessoal/funcionario-movimentacao/ListagemFuncionarioMovimentacoes"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "cadastro.FuncionarioMovimentacoes",
        path: "dashboard/funcionarioMovimentacoes/cadastro",
        component: () =>
          import(
            "@/components/pessoal/funcionario-movimentacao/CadastroFuncionarioMovimentacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "editar.funcionariomovimentacoes",
        path: "dashboard/funcionarioMovimentacoes/:id/editar",
        component: () =>
          import(
            "@/components/pessoal/funcionario-movimentacao/EditarFuncionarioMovimentacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },

      {
        name: "MovimentacaoDiariaOrigemExternas",
        path: "dashboard/movimentacoesDiariasOrigemExterna",
        component: () =>
          import(
            "@/components/operacoes/movimentacao-diaria-origem-externa/ListagemMovimentacaoDiariaOrigemExterna"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "cadastro.MovimentacaoDiariaOrigemExterna",
        path: "dashboard/movimentacoesDiariasOrigemExterna/cadastro",
        component: () =>
          import(
            "@/components/operacoes/movimentacao-diaria-origem-externa/CadastroMovimentacaoDiariaOrigemExterna"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "editar.movimentacaodiariaorigemexterna",
        path: "dashboard/movimentacoesDiariasOrigemExterna/:id/editar",
        component: () =>
          import(
            "@/components/operacoes/movimentacao-diaria-origem-externa/EditarMovimentacaoDiariaOrigemExterna"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      {
        name: "MovimentacaoDiariaMotivoCoberturas",
        path: "dashboard/movimentacoesDiariasMotivoCobertura",
        component: () =>
          import(
            "@/components/operacoes/movimentacao-diaria-motivo-cobertura/ListagemMovimentacaoDiariaMotivoCobertura"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "cadastro.MovimentacaoDiariaMotivoCobertura",
        path: "dashboard/movimentacoesDiariasMotivoCobertura/cadastro",
        component: () =>
          import(
            "@/components/operacoes/movimentacao-diaria-motivo-cobertura/CadastroMovimentacaoDiariaMotivoCobertura"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "editar.movimentacaodiariamotivocobertura",
        path: "dashboard/movimentacoesDiariasMotivoCobertura/:id/editar",
        component: () =>
          import(
            "@/components/operacoes/movimentacao-diaria-motivo-cobertura/EditarMovimentacaoDiariaMotivoCobertura"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      {
        name: "MovimentacaoDiarias",
        path: "dashboard/movimentacoesDiarias",
        component: () =>
          import(
            "@/components/operacoes/movimentacao-diaria/ListagemMovimentacaoDiaria"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "cadastro.MovimentacaoDiaria",
        path: "dashboard/movimentacoesDiarias/cadastro",
        component: () =>
          import(
            "@/components/operacoes/movimentacao-diaria/CadastroMovimentacaoDiaria"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "editar.movimentacaodiaria",
        path: "dashboard/movimentacoesDiarias/:id/editar",
        component: () =>
          import(
            "@/components/operacoes/movimentacao-diaria/EditarMovimentacaoDiaria"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      {
        name: "Cfops",
        path: "dashboard/cfops",
        component: () => import("@/components/comercial/cfop/ListagemCfops"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      /*         {
        name: "txt",
        path: "dashboard/txt",
        component: () => import("@/components/"),
        beforeEnter: ifAuthenticated,  
meta: {
          groupName: "Cajupe",
        },
      },
      {
        name: "editar.txT",
        path: "dashboard/txt/:id/editar",
        component: () => import("@/components//Editar"),
        beforeEnter: ifAuthenticated,  
meta: {
          groupName: "Cajupe",
        },
      },
      {
        name: "cadastro.txT",
        path: "dashboard/txt/cadastro",
        component: () => import("@/components//Editar"),
        beforeEnter: ifAuthenticated,  
meta: {
          groupName: "Cajupe",
        },
      }, */
      {
        name: "cadastro.Cfop",
        path: "dashboard/cfops/cadastro",
        component: () => import("@/components/comercial/cfop/CadastroCfop"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },

      {
        name: "editar.cfop",
        path: "dashboard/cfops/:id/editar",
        component: () => import("@/components/comercial/cfop/EditarCfop"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },

      {
        name: "cfopCidades",
        path: "dashboard/cfopCidades",
        component: () =>
          import("@/components/comercial/cfopCidades/ListagemCfopCidades"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "cadastro.CfopCidade",
        path: "dashboard/cfopCidades/cadastro",
        component: () =>
          import("@/components/comercial/cfopCidades/CadastroCfopCidade"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "editar.cfopcidade",
        path: "dashboard/cfopCidades/:id/editar",
        component: () =>
          import("@/components/comercial/cfopCidades/EditarCfopCidade"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },

      {
        name: "cfopEstados",
        path: "dashboard/cfopEstados",
        component: () =>
          import("@/components/comercial/cfopEstados/ListagemCfopEstados"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "cadastro.CfopEstado",
        path: "dashboard/cfopEstados/cadastro",
        component: () =>
          import("@/components/comercial/cfopEstados/CadastroCfopEstado"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },
      {
        name: "editar.cfopestado",
        path: "dashboard/cfopEstados/:id/editar",
        component: () =>
          import("@/components/comercial/cfopEstados/EditarCfopEstado"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Comercial",
        },
      },

      {
        name: "cadastro.EmailMarketing",
        path: "dashboard/enviarEmailMarketing",
        component: () =>
          import("@/components/email-marketing/EnviarEmailMarketing"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Marketing",
        },
      },
      {
        name: "EmailMarketing",
        path: "dashboard/EmailMarketing",
        component: () =>
          import("@/components/email-marketing/ListagemEmailMarketing"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Marketing",
        },
      },

      {
        name: "GraficosPeriodo",
        path: "dashboard/relatorios/funcionariopontos",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/graficos/modelo01/Graficos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },

      {
        name: "GraficosPeriodoMod02",
        path: "dashboard/relatorios/funcionariopontos/mod02",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/graficos/modelo01/Graficos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },

      {
        name: "GraficoRegistrosPonto",
        path: "dashboard/relatorios/funcionarioregistrosponto",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/graficos/registro-ponto/DashboardModelo01"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },

      {
        name: "Dashboard_de_absenteismo",
        path: "dashboard/relatorios/absenteismo",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/graficos/absenteismo/DashboardModelo01"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },

      {
        name: "Relatorio_registros_fora_tolerancia",
        path: "dashboard/relatorios/registrosForaTolerancia",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/graficos/RegistrosForaTolerancia"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },

      {
        name: "Relatorio_registros_duplicados",
        path: "dashboard/relatorios/registrosDuplicados",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/graficos/RegistrosDuplicados"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },

      {
        name: "Monitoramento_registradores_externos",
        path: "dashboard/relatorios/monitoramentoRegistradoresExternos",
        component: () =>
          import(
            "@/components/pessoal/registrador-ponto-externo/MonitoramentoRegistradoresExternos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },

      {
        name: "Relatorio_aniversariantes_periodo",
        path: "dashboard/relatorios/aniversariantesPeriodo",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/graficos/AniversariantesPeriodo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },

      {
        name: "Relatorio_funcionarios_multiplos_contratos",
        path: "dashboard/relatorios/funcionariosMultiplosContratos",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/graficos/FuncionariosComMultiplosContratos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },

      {
        name: "Auditoria_local_registros_de_ponto",
        path: "dashboard/relatorios/auditoriaLocalRegistrosPonto",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/graficos/AuditoriaLocalRegistrosPonto"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "Ausencia_registros_ponto",
        path: "dashboard/relatorios/ausenciaRegistrosPonto",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/graficos/AusenciaRegistrosPonto"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "Ocorrencias_apuracao_ponto",
        path: "dashboard/relatorios/ocorrenciasApuracaoPonto",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/graficos/OcorrenciasApuracaoPonto"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "Presenca_ausencia_ponto",
        path: "dashboard/relatorios/presencaAusenciaPonto",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/graficos/PresencaAusenciaPonto"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "Horas_apuradas_ponto",
        path: "dashboard/relatorios/horasApuradasPonto",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/graficos/HorasApuradasPonto"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },
      {
        name: "Registros_por_equipamento_ponto",
        path: "dashboard/relatorios/registrosPorEquipamento",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto/graficos/RegistrosEquipamentoPonto"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Ponto-RRP",
        },
      },

      {
        name: "funcionarioAfastamentos",
        path: "dashboard/funcionarioAfastamentos",
        component: () =>
          import(
            "@/components/pessoal/funcionario-afastamento/ListagemFuncionarioAfastamentos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "cadastro.FuncionarioAfastamentos",
        path: "dashboard/funcionarioAfastamentos/cadastro",
        component: () =>
          import(
            "@/components/pessoal/funcionario-afastamento/CadastroFuncionarioAfastamento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "editar.funcionarioafastamento",
        path: "dashboard/funcionarioAfastamentos/:id/editar",
        component: () =>
          import(
            "@/components/pessoal/funcionario-afastamento/EditarFuncionarioAfastamento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "FuncionarioPeriodosAquisitivos",
        path: "dashboard/funcionarioPeriodosAquisitivos",
        component: () =>
          import(
            "@/components/pessoal/funcionario-periodo-aquisitivo/ListagemFuncionarioPeriodoAquisitivo"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GESTAOFERIAS" },
      },
      {
        name: "cadastro.FuncionarioPeriodoAquisitivo",
        path: "dashboard/funcionarioPeriodosAquisitivos/cadastro",
        component: () =>
          import(
            "@/components/pessoal/funcionario-periodo-aquisitivo/CadastroFuncionarioPeriodoAquisitivo"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GESTAOFERIAS" },
      },
      {
        name: "editar.funcionarioperiodoaquisitivo",
        path: "dashboard/funcionarioPeriodosAquisitivos/:id/editar",
        component: () =>
          import(
            "@/components/pessoal/funcionario-periodo-aquisitivo/EditarFuncionarioPeriodoAquisitivo"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GESTAOFERIAS" },
      },
      {
        name: "DashboardFeriasPeriodosAquisitivos",
        path: "dashboard/relatorios/feriasPeriodosAquisitivos",
        component: () =>
          import(
            "@/components/pessoal/funcionario-periodo-aquisitivo/DashboardFeriasPeriodosAquisitivos"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GESTAOFERIAS" },
      },
      {
        name: "DashboardProgramacaoFerias",
        path: "dashboard/relatorios/programacaoFerias",
        component: () =>
          import(
            "@/components/pessoal/funcionario-periodo-aquisitivo/DashboardProgramacaoFerias"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GESTAOFERIAS" },
      },
      {
        name: "FuncionarioBancoHorasContratos",
        path: "dashboard/FuncionarioBancoHorasContratos",
        component: () =>
          import("@/components/pessoal/banco-de-horas/ListagemBancoHoras"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "cadastro.FuncionarioBancoHorasContratos",
        path: "dashboard/FuncionarioBancoHorasContratos/cadastro",
        component: () =>
          import("@/components/pessoal/banco-de-horas/CadastroBancoHora"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "cadastro.FuncionarioBancoHorasContratosSaldo",
        path: "dashboard/FuncionarioBancoHorasContratos/cadastro/saldo",
        component: () =>
          import("@/components/pessoal/banco-de-horas/CadastroBancoHoraSaldo"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "editar.funcionariobancohorascontrato",
        path: "dashboard/FuncionarioBancoHorasContratos/:id/editar",
        component: () =>
          import("@/components/pessoal/banco-de-horas/EditarBancoHora"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "gestaoEfetivo",
        path: "dashboard/gestaoEfetivo",
        component: () =>
          import("@/components/pessoal/gestao-efetivo/ListagemGestaoEfetivo"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "centroComandoOperacional",
        path: "dashboard/gestaoEfetivo/centroComandoOperacional",
        component: () =>
          import(
            "@/components/pessoal/gestao-efetivo/CentroComandoOperacional"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "gestaoEfetivoAnalise",
        path: "dashboard/gestaoEfetivo/analise",
        component: () =>
          import(
            "@/components/pessoal/gestao-efetivo/DashboardGestaoEfetivoAnalise"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },

      {
        name: "PedidoMateriais",
        path: "dashboard/pedidoMateriais",
        component: ListagemPedidoMaterial,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "Cadastro.pedidoMaterial",
        path: "dashboard/pedidoMateriais/cadastro",
        component: CadastroPedidoMaterial,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "editar.pedidomaterial",
        path: "dashboard/pedidoMaterial/:id/editar",
        component: EditarPedidoMaterial,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },

      {
        name: "PedidoUniformes",
        path: "dashboard/PedidoUniformes",
        component: ListagemPedidoUniforme,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "Cadastro.pedidoUniforme",
        path: "dashboard/pedidoUniformes/cadastro",
        component: CadastroPedidoUniforme,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "editar.pedidouniforme",
        path: "dashboard/pedidoUniforme/:id/editar",
        component: EditarPedidoUniforme,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },

      {
        name: "PedidoConsumiveisProprios",
        path: "dashboard/meusPedidosConsumiveis",
        component: () =>
          import(
            "@/components/recursos/pedido-consumivel-proprio/ListagemPedidos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "Cadastro.pedidoConsumivelProprio",
        path: "dashboard/meusPedidosConsumiveis/cadastro",
        component: () =>
          import(
            "@/components/recursos/pedido-consumivel-proprio/CadastroPedido"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "editar.pedidoconsumivelproprio",
        path: "dashboard/meusPedidosConsumiveis/:id/editar",
        component: () =>
          import(
            "@/components/recursos/pedido-consumivel-proprio/EditarPedido"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "PedidoConsumiveis",
        path: "dashboard/PedidoConsumiveis",
        component: ListagemPedidoConsumivel,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "Cadastro.pedidoConsumivel",
        path: "dashboard/pedidoConsumiveis/cadastro",
        component: CadastroPedidoConsumivel,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "editar.pedidoconsumivel",
        path: "dashboard/pedidoConsumivel/:id/editar",
        component: EditarPedidoConsumivel,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },

      {
        name: "ContaFinanceiras",
        path: "dashboard/ContaFinanceiras",
        component: () =>
          import(
            "@/components/financeiro/conta-financeira/ListagemContaFinanceira"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "ContaFinanceirasConta",
        path: "dashboard/ContaFinanceirasConta",
        component: () =>
          import(
            "@/components/financeiro/conta-financeira/ListagemContaFinanceiraConta"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "ContaFinanceiraNiveis",
        path: "dashboard/contaFinanceiraNiveis",
        component: () =>
          import(
            "@/components/financeiro/conta-financeira-nivel/ListagemContaFinanceiraNivel"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "cadastro.contaFinanceira",
        path: "dashboard/contaFinanceiras/cadastro",
        component: () =>
          import(
            "@/components/financeiro/conta-financeira/CadastroContaFinanceira"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "editar.contafinanceira",
        path: "dashboard/contaFinanceira/:id/editar",
        component: () =>
          import(
            "@/components/financeiro/conta-financeira/EditarContaFinanceira"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "cadastro.contaFinanceiraNivel",
        path: "dashboard/contaFinanceiraNiveis/cadastro",
        component: () =>
          import(
            "@/components/financeiro/conta-financeira-nivel/CadastroContaFinanceiraNivel"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "editar.contafinanceiranivel",
        path: "dashboard/contaFinanceiraNiveis/:id/editar",
        component: () =>
          import(
            "@/components/financeiro/conta-financeira-nivel/EditarContaFinanceiraNivel"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "ImobilizadoClassificacoes",
        path: "dashboard/ImobilizadoClassificacoes",
        component: () =>
          import(
            "@/components/recursos/imobilizado-classificacao/ListagemImobilizadoClassificacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "Imobilizados",
        path: "dashboard/Imobilizados",
        component: () =>
          import("@/components/recursos/imobilizados/ListagemImobilizado"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "cadastro.Imobilizado",
        path: "dashboard/Imobilizados/cadastro",
        component: () =>
          import("@/components/recursos/imobilizados/CadastroImobilizado"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "editar.imobilizado",
        path: "dashboard/Imobilizado/:id/editar",
        component: () =>
          import("@/components/recursos/imobilizados/EditarImobilizado"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },

      {
        name: "ImobilizadoMovimentacoes",
        path: "dashboard/ImobilizadoMovimentacoes",
        component: () =>
          import(
            "@/components/recursos/imobilizado-movimentacoes/ListagemImobilizadoMovimentacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "cadastro.ImobilizadoMovimentacao",
        path: "dashboard/ImobilizadoMovimentacoes/cadastro",
        component: () =>
          import(
            "@/components/recursos/imobilizado-movimentacoes/CadastroImobilizadoMovimentacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "editar.imobilizadomovimentacao",

        path: "dashboard/ImobilizadoMovimentacao/:id/editar",
        component: () =>
          import(
            "@/components/recursos/imobilizado-movimentacoes/EditarImobilizadoMovimentacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "ImobilizadoMovimentacaoConsulta",
        path: "dashboard/imobilizadoMovimentacaoConsulta",
        component: () =>
          import(
            "@/components/recursos/imobilizado-movimentacoes/ListagemImobilizadoMovimentacaoConsulta"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "PainelRetornoImobilizados",
        path: "dashboard/imobilizadoMovimentacoes/retornos",
        component: () =>
          import(
            "@/components/recursos/imobilizado-movimentacoes/PainelRetornoImobilizados.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },

      {
        name: "FuncionarioFolhaPagamentoPeriodos",
        path: "dashboard/FuncionarioFolhaPagamentoPeriodos",
        component: () =>
          import(
            "@/components/pessoal/funcionario-folha-pagamento-periodo/ListagemFuncionarioFolhaPagamentoPeriodo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "FuncionarioFolhaPagamentos",
        path: "dashboard/FuncionarioFolhaPagamentos",
        component: () =>
          import(
            "@/components/pessoal/funcionario-folha-pagamento/ListagemFuncionarioFolhaPagamento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "DashboardFolhaPagamento",
        path: "dashboard/relatorios/dashboardFolhaPagamento",
        component: () =>
          import(
            "@/components/pessoal/funcionario-folha-pagamento/DashboardFolhaPagamento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "cadastro.FuncionarioFolhaPagamentoPeriodo",
        path: "dashboard/FuncionarioFolhaPagamentoPeriodos/cadastro",
        component: () =>
          import(
            "@/components/pessoal/funcionario-folha-pagamento-periodo/CadastroFuncionarioFolhaPagamentoPeriodo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "editar.funcionariofolhapagamentoperiodo",

        path: "dashboard/FuncionarioFolhaPagamentoPeriodo/:id/editar",
        component: () =>
          import(
            "@/components/pessoal/funcionario-folha-pagamento-periodo/EditarFuncionarioFolhaPagamentoPeriodo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        path: "dashboard/esocialImportacao",
        component: () =>
          import(
            "@/components/pessoal/esocial-importacao/CentralESocialImportacao.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "ESocial",
        },
        children: [
          {
            path: "",
            name: "ESocialImportacaoCentral",
            redirect: () => {
              if (!store.getters.isAuthenticated) return "/login";
              if (!userHasPermission("ROLE_MENU_ESocial")) return "/dashboard";
              if (userHasPermission("ROLE_MENU_ESocial_ImportacaoManual")) {
                return { name: "ESocialImportacaoManual" };
              }
              if (userHasPermission("ROLE_MENU_ESocial_Configuracao")) {
                return { name: "ESocialImportacaoConfiguracao" };
              }
              if (userHasPermission("ROLE_MENU_ESocial_Acompanhamento")) {
                return { name: "ESocialImportacaoAcompanhamento" };
              }
              if (userHasPermission("ROLE_MENU_ESocial_Envio")) {
                return { name: "ESocialEnvioAcompanhamento" };
              }
              return "/dashboard";
            },
          },
          {
            path: "manual",
            name: "ESocialImportacaoManual",
            component: () =>
              import(
                "@/components/pessoal/esocial-importacao/ManualESocialImportacao.vue"
              ),
            meta: {
              groupName: "ESocial",
              permission: "ROLE_MENU_ESocial_ImportacaoManual",
            },
          },
          {
            path: "configuracao",
            name: "ESocialImportacaoConfiguracao",
            component: () =>
              import(
                "@/components/pessoal/esocial-importacao/ConfiguracaoESocialImportacao.vue"
              ),
            meta: {
              groupName: "ESocial",
              permission: "ROLE_MENU_ESocial_Configuracao",
            },
          },
          {
            path: "acompanhamento",
            name: "ESocialImportacaoAcompanhamento",
            component: () =>
              import(
                "@/components/pessoal/esocial-importacao/AcompanhamentoESocialImportacao.vue"
              ),
            meta: {
              groupName: "ESocial",
              permission: "ROLE_MENU_ESocial_Acompanhamento",
            },
          },
          {
            path: "envio",
            name: "ESocialEnvioAcompanhamento",
            component: () =>
              import(
                "@/components/pessoal/esocial-envio/AcompanhamentoESocialEnvio.vue"
              ),
            meta: {
              groupName: "ESocial",
              permission: "ROLE_MENU_ESocial_Envio",
            },
          },
          {
            path: "tabelas",
            name: "ESocialTabelas",
            component: () =>
              import("@/components/pessoal/esocial-envio/TabelasESocial.vue"),
            meta: {
              groupName: "ESocial",
              permission: "ROLE_MENU_ESocial_Envio",
            },
          },
        ],
      },

      {
        path: "dashboard/folhaCalculo",
        component: () =>
          import("@/components/pessoal/folha-calculo/CentralFolhaCalculo.vue"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "CFP",
        },
        children: [
          {
            path: "",
            name: "FolhaCalculoCentral",
            redirect: () => {
              const tela = TELAS_FOLHA_CALCULO.find(([, , , permissoes]) =>
                userHasAnyPermission(permissoes)
              );
              return tela ? { name: tela[1] } : "/dashboard";
            },
          },
          ...TELAS_FOLHA_CALCULO.map(([path, name, arquivo, permissions]) => ({
            path,
            name,
            component: () =>
              import(`@/components/pessoal/folha-calculo/${arquivo}.vue`),
            beforeEnter: ifAuthenticatedFolhaCalculo,
            meta: { groupName: "CFP", permissions },
          })),
          // As rubricas são as verbas da folha: a configuração do cálculo fica no cadastro delas.
          {
            path: "rubricas",
            redirect: "/dashboard/funcionarioFolhaPagamentoVerbas",
          },
          // Férias, rescisões e lançamentos ficam na mesma tela da folha, pelo tipo selecionado (parâmetro fora da URL).
          ...[
            ["ferias", "FERIAS"],
            ["rescisoes", "RESCISAO"],
            ["lancamentos", "MENSAL"],
          ].map(([path, tipo]) => ({
            path,
            redirect: () => {
              pedirTipoFolha(tipo);
              return { name: "FolhaCalculoFolhas", params: { tipo } };
            },
          })),
        ],
      },

      {
        name: "CalculoFaturamento",
        path: "dashboard/calculoFaturamentos",
        component: () =>
          import(
            "@/components/faturamento/calculo-faturamento/ListagemCalculoFaturamento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },

      {
        name: "PracaFiscais",
        path: "dashboard/PracaFiscais",
        component: () =>
          import("@/components/faturamento/praca-fiscal/ListagemPracaFiscal"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },
      {
        name: "cadastro.PracaFiscal",
        path: "dashboard/PracaFiscais/cadastro",
        component: () =>
          import("@/components/faturamento/praca-fiscal/CadastroPracaFiscal"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },
      {
        name: "editar.faturamentopracafiscal",
        path: "dashboard/PracaFiscal/:id/editar",
        component: () =>
          import("@/components/faturamento/praca-fiscal/EditarPracaFiscal"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },

      {
        name: "DocumentoFiscal",
        path: "dashboard/documentoFiscais",
        component: () =>
          import(
            "@/components/faturamento/documento-fiscal/ListagemDocumentoFiscal"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },
      {
        name: "cadastro.faturamentodocumentofiscal",
        path: "dashboard/DocumentoFiscal/cadastro",
        component: () =>
          import(
            "@/components/faturamento/documento-fiscal/CadastroDocumentoFiscal"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },
      {
        name: "editar.faturamentodocumentofiscal",
        path: "dashboard/DocumentoFiscal/:id/editar",
        component: () =>
          import(
            "@/components/faturamento/documento-fiscal/EditarDocumentoFiscal"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },
      {
        name: "FaturamentoPeriodo",
        path: "dashboard/faturamentoPeriodos",
        component: () =>
          import(
            "@/components/faturamento/faturamento-periodo/ListagemFaturamentoPeriodos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },
      {
        name: "cadastro.FaturamentoPeriodo",
        path: "dashboard/faturamentoPeriodos/cadastro",
        component: () =>
          import(
            "@/components/faturamento/faturamento-periodo/CadastroFaturamentoPeriodo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },
      {
        name: "editar.faturamentoperiodo",
        path: "dashboard/faturamentoPeriodos/:id/editar",
        component: () =>
          import(
            "@/components/faturamento/faturamento-periodo/EditarFaturamentoPeriodo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },

      {
        name: "BeneficioConvenios",
        path: "dashboard/BeneficioConvenios",
        component: () =>
          import(
            "@/components/pessoal/beneficio/convenio/ListagemBeneficioConvenio"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Beneficio-BEN",
        },
      },
      {
        name: "cadastro.BeneficioConvenio",
        path: "dashboard/BeneficioConvenios/cadastro",
        component: () =>
          import(
            "@/components/pessoal/beneficio/convenio/CadastroBeneficioConvenio"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Beneficio-BEN",
        },
      },
      {
        name: "editar.beneficioconvenio",
        path: "dashboard/BeneficioConvenio/:id/editar",
        component: () =>
          import(
            "@/components/pessoal/beneficio/convenio/EditarBeneficioConvenio"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Beneficio-BEN",
        },
      },

      {
        name: "BeneficioConvenioOptantes",
        path: "dashboard/BeneficioConvenioOptantes",
        component: () =>
          import(
            "@/components/pessoal/beneficio/optante/ListagemBeneficioConvenioOptante"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Beneficio-BEN",
        },
      },
      {
        name: "cadastro.BeneficioConvenioOptante",
        path: "dashboard/BeneficioConvenioOptantes/cadastro",
        component: () =>
          import(
            "@/components/pessoal/beneficio/optante/CadastroBeneficioConvenioOptante"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Beneficio-BEN",
        },
      },
      {
        name: "editar.beneficioconveniooptante",
        path: "dashboard/BeneficioConvenioOptante/:id/editar",
        component: () =>
          import(
            "@/components/pessoal/beneficio/optante/EditarBeneficioConvenioOptante"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Beneficio-BEN",
        },
      },

      {
        name: "BeneficioPeriodoApuracoes",
        path: "dashboard/BeneficioPeriodoApuracoes",
        component: () =>
          import(
            "@/components/pessoal/beneficio/periodo/ListagemBeneficioPeriodoApuracao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Beneficio-BEN",
        },
      },
      {
        name: "cadastro.BeneficioPeriodoApuracao",
        path: "dashboard/BeneficioPeriodoApuracoes/cadastro",
        component: () =>
          import(
            "@/components/pessoal/beneficio/periodo/CadastroBeneficioPeriodoApuracao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Beneficio-BEN",
        },
      },
      {
        name: "editar.beneficioperiodoapuracao",
        path: "dashboard/BeneficioPeriodoApuracao/:id/editar",
        component: () =>
          import(
            "@/components/pessoal/beneficio/periodo/EditarBeneficioPeriodoApuracao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Beneficio-BEN",
        },
      },

      {
        name: "BeneficioApuracao",
        path: "dashboard/BeneficioApuracoes",
        component: () =>
          import(
            "@/components/pessoal/beneficio/calculo/ListagemBeneficioApuracao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Beneficio-BEN",
        },
      },

      {
        name: "usuarioPerfis",
        path: "dashboard/usuarioPerfis",
        component: () => import("@/components/acessos/perfis/ListagemPerfil"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },
      {
        name: "cadastro.Perfil",
        path: "dashboard/usuarioPerfis/cadastro",
        component: () => import("@/components/acessos/perfis/CadastroPerfil"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },
      {
        name: "editar.usuarioperfil",
        path: "dashboard/usuarioPerfis/:id/editar",
        component: () => import("@/components/acessos/perfis/EditarPerfil"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },

      {
        name: "permissoes",
        path: "dashboard/permissoes",
        component: () =>
          import("@/components/acessos/permissoes/ListagemPermissao"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },
      {
        name: "cadastro.Permissao",
        path: "dashboard/permissoes/cadastro",
        component: () =>
          import("@/components/acessos/permissoes/CadastroPermissao"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },
      {
        name: "editar.permissao",
        path: "dashboard/permissoes/:id/editar",
        component: () =>
          import("@/components/acessos/permissoes/EditarPermissao"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },
      {
        name: "LogAuditoria",
        path: "dashboard/logTransacoes",
        component: ListagemLogAuditoria,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },
      {
        name: "OperacoesPendentesTransacoes",
        path: "dashboard/operacoesPendentesTransacoes",
        component: ListagemOperacaoPendenteTransacao,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },
      {
        name: "WhatsappProcessos",
        path: "dashboard/whatsappProcessos",
        component: () =>
          import(
            "@/components/software/whatsapp-processos/ListagemWhatsappProcessos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },
      {
        name: "FaceDescriptors",
        path: "dashboard/faceDescriptors",
        component: () =>
          import(
            "@/components/software/face-descriptors/ListagemFaceDescriptors"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },
      {
        name: "cadastro.faceDescriptor",
        path: "dashboard/faceDescriptors/cadastro",
        component: () =>
          import(
            "@/components/software/face-descriptors/CadastroFaceDescriptor"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },
      {
        name: "editar.facedescriptor",
        path: "dashboard/faceDescriptors/:id/editar",
        component: () =>
          import("@/components/software/face-descriptors/EditarFaceDescriptor"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },

      {
        name: "beneficio.analise.cliente",
        path: "dashboard/BeneficioAnalise/cliente",
        component: () =>
          import("@/components/pessoal/beneficio/analise-cliente/Realizado"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Beneficio-BEN",
        },
      },
      {
        name: "beneficio.direitos.dashboard",
        path: "dashboard/BeneficioDireitos",
        component: () =>
          import(
            "@/components/pessoal/beneficio/dashboard-direitos/DashboardDireitosBeneficio"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Beneficio-BEN",
        },
      },
      {
        name: "MetodoCobrancas",
        path: "dashboard/metodocobrancas",
        component: () =>
          import(
            "@/components/comercial/metodo-cobranca/ListagemMetodoCobranca"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },
      {
        name: "cadastro.MetodoCobranca",
        path: "dashboard/metodocobrancas/cadastro",
        component: () =>
          import(
            "@/components/comercial/metodo-cobranca/CadastroMetodoCobranca"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },

      {
        name: "editar.metodocobranca",
        path: "dashboard/metodocobrancas/:id/editar",
        component: () =>
          import("@/components/comercial/metodo-cobranca/EditarMetodoCobranca"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },

      {
        name: "CompraPedidos",
        path: "dashboard/comprapedidos",
        component: () =>
          import(
            "@/components/recursos/compras/compra-pedido/ListagemCompraPedido"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Compras",
        },
      },
      {
        name: "cadastro.Comprapedidos",
        path: "dashboard/comprapedidos/cadastro",
        component: () =>
          import(
            "@/components/recursos/compras/compra-pedido/CadastroCompraPedido"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Compras",
        },
      },

      {
        name: "editar.comprapedidos",
        path: "dashboard/comprapedidos/:id/editar",
        component: () =>
          import(
            "@/components/recursos/compras/compra-pedido/EditarCompraPedido"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Compras",
        },
      },
      {
        name: "CompraOrcamentos",
        path: "dashboard/compraorcamentos",
        component: () =>
          import(
            "@/components/recursos/compras/compra-orcamento/ListagemCompraOrcamento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Compras",
        },
      },
      {
        name: "cadastro.Compraorcamentos",
        path: "dashboard/compraorcamentos/cadastro",
        component: () =>
          import(
            "@/components/recursos/compras/compra-orcamento/CadastroCompraOrcamento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Compras",
        },
      },

      {
        name: "editar.compraorcamentos",
        path: "dashboard/compraorcamentos/:id/editar",
        component: () =>
          import(
            "@/components/recursos/compras/compra-orcamento/EditarCompraOrcamento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Compras",
        },
      },

      {
        name: "CaixaForte",
        path: "dashboard/caixaForte",
        component: () =>
          import("@/components/operacoes/caixaForte/ListagemCaixaForte"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GCF",
        },
      },
      {
        name: "cadastro.CaixaForte",
        path: "dashboard/caixaForte/cadastro",
        component: () =>
          import("@/components/operacoes/caixaForte/CadastroCaixaForte"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GCF",
        },
      },

      {
        name: "editar.caixaforte",
        path: "dashboard/caixaForte/:id/editar",
        component: () =>
          import("@/components/operacoes/caixaForte/EditarCaixaForte"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GCF",
        },
      },
      {
        name: "CaixaForteFechamento",
        path: "dashboard/caixaForteFechamento",
        component: () =>
          import(
            "@/components/operacoes/caixaForte/ListagemCaixaForteFechamento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GCF",
        },
      },
      {
        name: "cadastro.CaixaForteFechamento",
        path: "dashboard/caixaForteFechamento/cadastro",
        component: () =>
          import(
            "@/components/operacoes/caixaForte/CadastroCaixaForteFechamento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GCF",
        },
      },
      {
        name: "editar.caixafortefechamento",
        path: "dashboard/caixaForteFechamento/:id/editar",
        component: () =>
          import(
            "@/components/operacoes/caixaForte/EditarCaixaForteFechamento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GCF",
        },
      },
      {
        name: "CaixaForteItem",
        path: "dashboard/caixaForteItem",
        component: () =>
          import("@/components/operacoes/transporte/ListagemCaixaForteItem"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GCF",
        },
      },
      {
        name: "RelatorioGuiasRotaSemEntrada",
        path: "dashboard/caixaForteItem/relatorio/guiasRotaSemEntrada",
        redirect: { name: "CaixaForteEntradasPendentes" },
      },
      {
        name: "CaixaForteEntradasPendentes",
        path: "dashboard/caixaForte/entradasPendentes",
        component: () =>
          import(
            "@/components/operacoes/caixaForte/RelatorioEntradasPendentesCaixaForte"
          ),
        beforeEnter: ifAuthenticatedEntradasPendentesCaixaForte,
        meta: {
          groupName: "GCF",
        },
      },
      {
        name: "CaixaForteAuditoria",
        path: "dashboard/caixaForteAuditoria",
        component: () =>
          import(
            "@/components/operacoes/caixaForte/ListagemCaixaForteAuditoria"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GCF",
        },
      },
      {
        name: "TransporteChaves",
        path: "dashboard/transporteChaves",
        component: () =>
          import(
            "@/components/operacoes/transporte-chave/ListagemTransporteChaves"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GCH",
        },
      },
      {
        name: "TransporteChaveAuditoria",
        path: "dashboard/transporteChaveAuditoria",
        component: () =>
          import(
            "@/components/operacoes/transporte-chave/ListagemTransporteChaveAuditoria"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GCH",
        },
      },
      {
        name: "cadastro.TransporteChave",
        path: "dashboard/transporteChaves/cadastro",
        component: () =>
          import(
            "@/components/operacoes/transporte-chave/CadastroTransporteChave"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GCH",
        },
      },
      {
        name: "editar.transportechave",
        path: "dashboard/transporteChaves/:id/editar",
        component: () =>
          import(
            "@/components/operacoes/transporte-chave/EditarTransporteChave"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GCH",
        },
      },
      {
        name: "TransporteChaveMovimentacoes",
        path: "dashboard/transporteChaveMovimentacoes",
        component: () =>
          import(
            "@/components/operacoes/transporte-chave-movimentacao/ListagemTransporteChaveMovimentacoes"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GCH",
        },
      },
      {
        name: "TransporteChaveMovimentacoesConsulta",
        path: "dashboard/transporteChaveMovimentacoes/consulta",
        component: () =>
          import(
            "@/components/operacoes/transporte-chave-movimentacao/ListagemTransporteChaveMovimentacoesConsulta"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GCH",
        },
      },
      {
        name: "ArmaFogoColeteBalisticoMovimentacoes",
        path: "dashboard/armaFogoColeteBalisticoMovimentacoes",
        component: () =>
          import(
            "@/components/operacoes/movimentacao-arma-fogo-colete-balistico/ListagemArmaFogoColeteBalisticoMovimentacoes"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAC",
        },
      },
      {
        name: "ArmaFogoColeteBalisticoMovimentacoesConsulta",
        path: "dashboard/armaFogoColeteBalisticoMovimentacoes/consulta",
        component: () =>
          import(
            "@/components/operacoes/movimentacao-arma-fogo-colete-balistico/ListagemArmaFogoColeteBalisticoMovimentacoesConsulta"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAC",
        },
      },
      {
        name: "CaixaForteSaldo",
        path: "dashboard/caixaForteSaldo",
        component: () =>
          import(
            "@/components/operacoes/caixaForte/AcompanhamentoCaixaForteSaldo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Cofre",
        },
      },
      {
        name: "cadastro.CaixaForteItem",
        path: "dashboard/caixaForteItem/cadastro",
        component: () =>
          import("@/components/operacoes/transporte/CadastroCaixaForteItem"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Cofre",
        },
      },

      {
        name: "editar.caixaforteitem",
        path: "dashboard/caixaForteItem/:id/editar",
        component: () =>
          import("@/components/operacoes/transporte/EditarCaixaForteItem"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Cofre",
        },
      },

      {
        name: "TesourariaArea",
        path: "dashboard/tesourariaAreas",
        component: () =>
          import("@/components/operacoes/tesouraria/ListagemTesourariaArea"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "cadastro.TesourariaArea",
        path: "dashboard/tesourariaAreas/cadastro",
        component: () =>
          import("@/components/operacoes/tesouraria/CadastroTesourariaArea"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "editar.tesourariaarea",
        path: "dashboard/tesourariaAreas/:id/editar",
        component: () =>
          import("@/components/operacoes/tesouraria/EditarTesourariaArea"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "Tesouraria",
        path: "dashboard/tesourarias",
        component: () =>
          import("@/components/operacoes/tesouraria/ListagemTesouraria"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "cadastro.Tesouraria",
        path: "dashboard/tesourarias/cadastro",
        component: () =>
          import("@/components/operacoes/tesouraria/CadastroTesouraria"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "editar.tesouraria",
        path: "dashboard/tesourarias/:id/editar",
        component: () =>
          import("@/components/operacoes/tesouraria/EditarTesouraria"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "OperacaoMoeda",
        path: "dashboard/operacaoMoedas",
        component: () =>
          import("@/components/operacoes/tesouraria/ListagemOperacaoMoeda"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "cadastro.OperacaoMoeda",
        path: "dashboard/operacaoMoedas/cadastro",
        component: () =>
          import("@/components/operacoes/tesouraria/CadastroOperacaoMoeda"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "editar.operacaomoeda",
        path: "dashboard/operacaoMoedas/:id/editar",
        component: () =>
          import("@/components/operacoes/tesouraria/EditarOperacaoMoeda"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "OperacaoMoedaCotacao",
        path: "dashboard/operacaoMoedaCotacoes",
        component: () =>
          import(
            "@/components/operacoes/tesouraria/ListagemOperacaoMoedaCotacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "cadastro.OperacaoMoedaCotacao",
        path: "dashboard/operacaoMoedaCotacoes/cadastro",
        component: () =>
          import(
            "@/components/operacoes/tesouraria/CadastroOperacaoMoedaCotacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "editar.operacaomoedacotacao",
        path: "dashboard/operacaoMoedaCotacoes/:id/editar",
        component: () =>
          import(
            "@/components/operacoes/tesouraria/EditarOperacaoMoedaCotacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "TesourariaSaidasConfirmacaoPendente",
        path: "dashboard/tesourariaSaidasConfirmacaoPendente",
        component: () =>
          import(
            "@/components/operacoes/tesouraria/RelatorioSaidasConfirmacaoPendenteTesouraria"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "Tesouraria" },
      },
      {
        name: "TesourariaMovimentacao",
        path: "dashboard/tesourariaMovimentacoes",
        component: () =>
          import(
            "@/components/operacoes/tesouraria/ListagemTesourariaMovimentacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "cadastro.TesourariaMovimentacao",
        path: "dashboard/tesourariaMovimentacoes/cadastro",
        component: () =>
          import(
            "@/components/operacoes/tesouraria/CadastroTesourariaMovimentacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "TesourariaTurno",
        path: "dashboard/tesourariaTurnos",
        component: () =>
          import("@/components/operacoes/tesouraria/ListagemTesourariaTurno"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "cadastro.TesourariaTurno",
        path: "dashboard/tesourariaTurnos/cadastro",
        component: () =>
          import("@/components/operacoes/tesouraria/CadastroTesourariaTurno"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "TesourariaDiferencaTipos",
        path: "dashboard/tesourariaDiferencaTipos",
        component: () =>
          import(
            "@/components/operacoes/tesouraria/ListagemTesourariaDiferencaTipo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "cadastro.TesourariaDiferencaTipo",
        path: "dashboard/tesourariaDiferencaTipos/cadastro",
        component: () =>
          import(
            "@/components/operacoes/tesouraria/CadastroTesourariaDiferencaTipo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "editar.tesourariadiferencatipo",
        path: "dashboard/tesourariaDiferencaTipos/:id/editar",
        component: () =>
          import(
            "@/components/operacoes/tesouraria/EditarTesourariaDiferencaTipo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "TesourariaRecontagem",
        path: "dashboard/tesourariaRecontagem",
        component: () =>
          import(
            "@/components/operacoes/tesouraria/OperacaoTesourariaRecontagem"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "TesourariaSaldo",
        path: "dashboard/tesourariaSaldo",
        component: () =>
          import("@/components/operacoes/tesouraria/DashboardTesourariaSaldo"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "TesourariaPosicao",
        path: "dashboard/tesourariaPosicao",
        component: () =>
          import(
            "@/components/operacoes/tesouraria/RelatorioPosicaoTesouraria"
          ),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "Tesouraria" },
      },
      {
        name: "TesourariaProdutividade",
        path: "dashboard/tesourariaProdutividade",
        component: () =>
          import(
            "@/components/operacoes/tesouraria/DashboardTesourariaProdutividade"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },
      {
        name: "TesourariaRecontagemBancada",
        path: "dashboard/tesourariaRecontagemBancadas",
        component: () =>
          import(
            "@/components/operacoes/tesouraria/DashboardTesourariaRecontagemBancada"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tesouraria",
        },
      },

      {
        name: "CompraOrdens",
        path: "dashboard/compraordens",
        component: () =>
          import(
            "@/components/recursos/compras/compra-ordem/ListagemCompraOrdem"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Compras",
        },
      },
      {
        name: "ComprasEmissoesCnpj",
        path: "dashboard/compras/emissoes-cnpj",
        component: () =>
          import(
            "@/components/recursos/compras/compras-emissoes-cnpj/ListagemComprasEmissoesCnpj"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Compras",
        },
      },
      {
        name: "MinhaSolicitacaoCompras",
        path: "dashboard/compras/minha-solicitacao",
        component: () =>
          import(
            "@/components/recursos/compras/compra-periodo/MinhaSolicitacaoCompras"
          ),
        beforeEnter: ifAuthenticatedMinhaSolicitacaoCompras,
        meta: {
          groupName: "Compras",
          permissions: ["ROLE_CompraPeriodoSolicitacaoPropria_List"],
        },
      },
      {
        name: "MinhaContagemEstoque",
        path: "dashboard/compras/minha-contagem",
        component: () =>
          import(
            "@/components/recursos/compras/compra-periodo/ContagemEstoqueCompras"
          ),
        beforeEnter: ifAuthenticatedMinhaContagemEstoque,
        meta: {
          groupName: "Compras",
          permissions: ["ROLE_CompraPeriodoSolicitacaoPropria_List"],
        },
      },
      {
        name: "FinalizarContagemEstoque",
        path: "dashboard/compras/minha-contagem/finalizar",
        component: () =>
          import(
            "@/components/recursos/compras/compra-periodo/FinalizarContagemEstoque"
          ),
        beforeEnter: ifAuthenticatedMinhaContagemEstoque,
        meta: {
          groupName: "Compras",
          permissions: ["ROLE_CompraPeriodoSolicitacaoPropria_Update"],
        },
      },
      {
        name: "ComprasPeriodos",
        path: "dashboard/compras/periodos",
        component: () =>
          import(
            "@/components/recursos/compras/compra-periodo/PeriodosCompras"
          ),
        beforeEnter: ifAuthenticatedComprasPeriodo,
        meta: {
          groupName: "Compras",
          permissions: ["ROLE_CompraPeriodo_List"],
        },
      },
      {
        name: "ValidacaoPedidoPeriodo",
        path: "dashboard/compras/periodos/pedido/:id/validacao",
        component: () =>
          import(
            "@/components/recursos/compras/compra-periodo/ValidacaoPedidoPeriodo"
          ),
        beforeEnter: ifAuthenticatedComprasPeriodo,
        meta: {
          groupName: "Compras",
          permissions: [
            "ROLE_CompraPeriodo_List",
            "ROLE_CompraPeriodo_Validar",
          ],
        },
      },
      {
        name: "ComprasEntregas",
        path: "dashboard/compras/entregas",
        component: () =>
          import(
            "@/components/recursos/compras/compra-entrega/PlanejamentoEntregas"
          ),
        beforeEnter: ifAuthenticatedComprasPeriodo,
        meta: {
          groupName: "Compras",
          permissions: ["ROLE_CompraEntrega_List"],
        },
      },
      {
        name: "ComprasRecebimentos",
        path: "dashboard/compras/recebimentos",
        component: () =>
          import(
            "@/components/recursos/compras/compra-entrega/RecebimentosCompras"
          ),
        beforeEnter: ifAuthenticatedComprasPeriodo,
        meta: {
          groupName: "Compras",
          permissions: [
            "ROLE_CompraEntregaRecebimento_Insert",
            "ROLE_CompraEntregaRecebimento_List",
          ],
        },
      },
      {
        name: "SolicitacaoCompras",
        path: "dashboard/solicitacaoCompras",
        component: () =>
          import(
            "@/components/recursos/compras/solicitacao-compra/ListagemSolicitacaoCompra"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GSC",
        },
      },

      {
        name: "cadastro.CertificadoA1",
        path: "dashboard/certificadosA1/cadastro",
        component: () =>
          import("@/components/software/certificados-a1/CadastroCertificadoA1"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },

      {
        name: "editar.certificadoa1",
        path: "dashboard/certificadosA1/:id/editar",
        component: () =>
          import("@/components/software/certificados-a1/EditarCertificadoA1"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },

      {
        name: "CertificadosA1",
        path: "dashboard/certificadosA1",
        component: () =>
          import(
            "@/components/software/certificados-a1/ListagemCertificadosA1"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },

      {
        name: "cadastro.Feriados",
        path: "dashboard/feriados/cadastro",
        component: () =>
          import("@/components/software/feriados/CadastroFeriado"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },

      {
        name: "editar.feriado",
        path: "dashboard/feriados/:id/editar",
        component: () => import("@/components/software/feriados/EditarFeriado"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },

      {
        name: "Feriados",
        path: "dashboard/feriados",
        component: () =>
          import("@/components/software/feriados/ListagemFeriados"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },

      {
        name: "faturamentovariaveisservicos",
        path: "dashboard/faturamentoVariaveisServicos",
        component: () =>
          import(
            "@/components/faturamento/variaveis-servico/ListagemVariaveisServico"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },
      {
        name: "cadastro.FaturamentoVariaveisServicos",
        path: "dashboard/faturamentoVariaveisServicos/cadastro",
        component: () =>
          import(
            "@/components/faturamento/variaveis-servico/CadastroVariaveisServico"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },
      {
        name: "editar.faturamentovariaveisservico",
        path: "dashboard/faturamentoVariaveisServicos/:id/editar",
        component: () =>
          import(
            "@/components/faturamento/variaveis-servico/EditarVariaveisServico"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },

      {
        name: "registrotarefaperiodo",
        path: "dashboard/registrotarefaperiodos",
        component: () =>
          import(
            "@/components/operacoes/tarefas/periodo/ListagemTarefasPeriodos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GestaoTarefasDiarias",
        },
      },
      {
        name: "cadastro.registrotarefaperiodo",
        path: "dashboard/registrotarefaperiodos/cadastro",
        component: () =>
          import(
            "@/components/operacoes/tarefas/periodo/CadastroTarefasPeriodo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GestaoTarefasDiarias",
        },
      },
      {
        name: "editar.registrotarefaperiodo",
        path: "dashboard/registrotarefaperiodos/:id/editar",
        component: () =>
          import("@/components/operacoes/tarefas/periodo/EditarTarefasPeriodo"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GestaoTarefasDiarias",
        },
      },
      {
        name: "RegistroTarefaCalculo",
        path: "dashboard/registrotarefacalculo",
        component: () =>
          import(
            "@/components/operacoes/tarefas/calculo/ListagemRegistrosTarefaApuracao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GestaoTarefasDiarias",
        },
      },
      {
        name: "lancamentosContabeis",
        path: "dashboard/lancamentocontabil",
        component: () =>
          import("@/components/contabilidade/LancamentoContabil"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Contabildade",
        },
      },

      {
        name: "AvisoPrevio",
        path: "dashboard/funcionarioavisoprevios",
        component: ListagemAvisoPrevio,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "cadastro.funcionarioAvisoPrevio",
        path: "dashboard/funcionarioavisoprevios/cadastro",
        component: CadastroAvisoPrevio,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "editar.funcionarioavisoprevio",
        path: "dashboard/funcionarioavisoprevio/:id/editar",
        component: EditarAvisoPrevio,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },

      {
        name: "ModeloDocumentacaoAcessoria",
        path: "dashboard/modeloDocumentacaoAcessorias",
        component: ListagemModeloDocumentacaoAcessoria,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "cadastro.modeloDocumentacaoAcessoria",
        path: "dashboard/modeloDocumentacaoAcessorias/cadastro",
        component: CadastroModeloDocumentacaoAcessoria,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "editar.modelodocumentacaoacessoria",
        path: "dashboard/modeloDocumentacaoAcessoria/:id/editar",
        component: EditarModeloDocumentacaoAcessoria,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "FuncionarioPreContratracaoDocumentos",
        path: "dashboard/funcionarioPreContratracaoDocumentos",
        component: ListagemFuncionarioPreContratracaoDocumentos,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "PRECONTRATACAO",
        },
      },
      {
        name: "cadastro.funcionarioPreContratracaoDocumentos",
        path: "dashboard/funcionarioPreContratracaoDocumentos/cadastro",
        component: CadastroFuncionarioPreContratracaoDocumentos,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "PRECONTRATACAO",
        },
      },
      {
        name: "editar.funcionarioprecontratracaodocumentos",
        path: "dashboard/funcionarioPreContratracaoDocumentos/:id/editar",
        component: EditarFuncionarioPreContratracaoDocumentos,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "PRECONTRATACAO",
        },
      },
      {
        name: "FuncionarioPreContratracao",
        path: "dashboard/funcionarioPreContratracao",
        component: ListagemFuncionarioPreContratracao,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "PRECONTRATACAO",
        },
      },
      {
        name: "cadastro.funcionarioPreContratracao",
        path: "dashboard/funcionarioPreContratracao/cadastro",
        component: CadastroFuncionarioPreContratracao,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "PRECONTRATACAO",
        },
      },
      {
        name: "editar.funcionarioprecontratracao",
        path: "dashboard/funcionarioPreContratracao/:id/editar",
        component: EditarFuncionarioPreContratracao,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "PRECONTRATACAO",
        },
      },
      {
        name: "FuncionarioPreContratracaoConfiguracao",
        path: "dashboard/funcionarioPreContratracaoConfiguracao",
        component: () =>
          import(
            "@/components/pessoal/funcionario-pre-contratacao/ConfiguracaoFuncionarioPreContratracao.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "PRECONTRATACAO",
        },
      },
      {
        name: "GestaoContratacao",
        path: "dashboard/gestaoContratacao",
        component: () =>
          import("@/components/pessoal/gestao-contratacao/GestaoContratacao.vue"),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GCT" },
      },
      {
        name: "GestaoContratacaoDashboard",
        path: "dashboard/gestaoContratacao/dashboard",
        component: () =>
          import("@/components/pessoal/gestao-contratacao/GestaoContratacaoDashboard.vue"),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GCT" },
      },
      {
        name: "RecrutamentoSolicitacao",
        path: "dashboard/recrutamentoSolicitacoes",
        component: () =>
          import("@/components/pessoal/gestao-contratacao/solicitacoes/ListagemRecrutamentoSolicitacao.vue"),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GCT" },
      },
      {
        name: "cadastro.RecrutamentoSolicitacao",
        path: "dashboard/recrutamentoSolicitacoes/cadastro",
        component: () =>
          import("@/components/pessoal/gestao-contratacao/solicitacoes/CadastroRecrutamentoSolicitacao.vue"),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GCT" },
      },
      {
        name: "editar.recrutamentosolicitacao",
        path: "dashboard/recrutamentoSolicitacoes/:id/editar",
        component: () =>
          import("@/components/pessoal/gestao-contratacao/solicitacoes/EditarRecrutamentoSolicitacao.vue"),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GCT" },
      },
      {
        name: "GestaoContratacaoVaga",
        path: "dashboard/gestaoContratacao/vagas/:id",
        component: () =>
          import("@/components/pessoal/gestao-contratacao/GestaoContratacaoVaga.vue"),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GCT" },
      },
      {
        name: "RecrutamentoBancoTalentos",
        path: "dashboard/gestaoContratacao/bancoTalentos",
        component: () =>
          import("@/components/pessoal/gestao-contratacao/BancoTalentos.vue"),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GCT" },
      },
      {
        name: "RecrutamentoDashboardEntrevistas",
        path: "dashboard/gestaoContratacao/dashboardEntrevistas",
        component: () =>
          import("@/components/pessoal/gestao-contratacao/DashboardEntrevistas.vue"),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GCT" },
      },
      {
        name: "RecrutamentoDashboardBancoTalentos",
        path: "dashboard/gestaoContratacao/dashboardBancoTalentos",
        component: () =>
          import("@/components/pessoal/gestao-contratacao/DashboardBancoTalentos.vue"),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GCT" },
      },
      {
        name: "GestaoContratacaoCandidato",
        path: "dashboard/gestaoContratacao/candidatos/:id",
        component: () =>
          import("@/components/pessoal/gestao-contratacao/CandidatoFicha.vue"),
        beforeEnter: ifAuthenticated,
        meta: { groupName: "GCT" },
      },
      {
        name: "OrcamentoDespesa",
        path: "dashboard/orcamentoDespesa",
        component: ListageOrcamentoDespesa,
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },
      {
        name: "DashboardOrcamentoDespesa",
        path: "dashboard/orcamentoDespesa/painel",
        component: () =>
          import(
            "@/components/financeiro/orcamento-despesa/DashboardOrcamentoDespesa"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Financeiro",
        },
      },

      {
        name: "funcionarioAfastamentoSolicitacao",
        path: "dashboard/funcionarioAfastamentoSolicitacoes",
        component: () =>
          import(
            "@/components/pessoal/funcionario-afastamento-solicitacao/ListagemFuncionarioAfastamentoSolicitacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "FuncionarioPontoSolicitacao",
        path: "dashboard/funcionarioPontoSolicitacoes",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto-solicitacao/ListagemFuncionarioPontoSolicitacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "importarHorarios",
        path: "dashboard/gestaoAcademicaHorarios",
        component: () =>
          import(
            "@/components/pessoal/funcionario-escala-trabalho/GestaoAcademicaHorarios"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "GAH",
        },
      },

      {
        name: "ContaVinculadaMovimentacoes",
        path: "dashboard/contaVinculadaMovimentacoes",
        component: () =>
          import(
            "@/components/financeiro/conta-vinculada-movimentacao/ListagemContaVinculadaMovimentacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "ContaVinculada",
        },
      },

      {
        name: "cadastro.ContaVinculadaMovimentacao",
        path: "dashboard/contaVinculadaMovimentacoes/cadastro",
        component: () =>
          import(
            "@/components/financeiro/conta-vinculada-movimentacao/CadastroContaVinculadaMovimentacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "ContaVinculada",
        },
      },
      {
        name: "editar.contavinculadamovimentacao",
        path: "dashboard/contaVinculadaMovimentacoes/:id/editar",
        component: () =>
          import(
            "@/components/financeiro/conta-vinculada-movimentacao/EditarContaVinculadaMovimentacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "ContaVinculada",
        },
      },

      {
        name: "Equipamentos",
        path: "dashboard/equipamentos",
        component: () =>
          import("@/components/operacoes/equipamentos/ListagemEquipamento"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "CentroDepositos",
        path: "dashboard/centroDepositos",
        component: () =>
          import(
            "@/components/operacoes/centro-deposito/ListagemCentroDeposito.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      {
        name: "CodigoIdentificacaoReciprocas",
        path: "dashboard/codigoIdentificacaoReciprocas",
        component: () =>
          import(
            "@/components/operacoes/codigoIdentificacaoReciproca/ListagemCodigoIdentificacaoReciproca"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      {
        name: "EquipamentoAnaliseMovimentacao",
        path: "dashboard/analiseMovimentacaoEquipamentos",
        component: () =>
          import("@/components/operacoes/equipamentos/AnaliseMovimentacao"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "AnaliseMovimentacaoCentroDeposito",
        path: "dashboard/analiseMovimentacaoCentroDeposito",
        component: () =>
          import(
            "@/components/operacoes/equipamentos/AnaliseMovimentacaoCentroDeposito.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      {
        name: "EquipamentoAnaliseCredito",
        path: "dashboard/analiseSaldoLogicoEquipamentos",
        component: () =>
          import("@/components/operacoes/equipamentos/AnaliseSaldoLogico"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      {
        name: "EquipamentoAnaliseMovimentacaoCliente",
        path: "dashboard/analiseMovimentacaoEquipamentos/cliente",
        component: () =>
          import(
            "@/components/operacoes/equipamentos/AnaliseMovimentacaoCliente"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      {
        name: "EquipamentoAnaliseCreditoCliente",
        path: "dashboard/analiseSaldoLogicoEquipamentos/cliente",
        component: () =>
          import(
            "@/components/operacoes/equipamentos/AnaliseSaldoLogicoCliente"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      {
        name: "EquipamentoEncerramentoApuracaoSaldoData",
        path: "dashboard/equipamentoEncerramentoApuracaoSaldoDatas",
        component: () =>
          import(
            "@/components/operacoes/equipamentoEncerramentoApuracaoSaldoData/ListagemEquipamentoEncerramentoApuracaoSaldoData"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      {
        name: "EquipamentosDashboard01",
        path: "dashboard/equipamentos/dashboard01",
        component: () =>
          import("@/components/operacoes/equipamentos/DashboardModelo01"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      {
        name: "LogisticaTipoEvento",
        path: "dashboard/logisticaTipoEvento",
        component: () =>
          import(
            "@/components/operacoes/logisticaTipoEvento/ListagemLogisticaTipoEvento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      {
        name: "LogisticaTipoOcorrencia",
        path: "dashboard/logisticaTipoOcorrencia",
        component: () =>
          import(
            "@/components/operacoes/logisticaTipoOcorrencia/ListagemLogisticaTipoOcorrencia"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },
      {
        name: "CentroEstoque",
        path: "dashboard/centroEstoques",
        component: () =>
          import("@/components/recursos/centro-estoque/ListagemCentroEstoque"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "ProdutosCentroEstoque",
        path: "dashboard/produtosCentroEstoque",
        component: () =>
          import(
            "@/components/recursos/centro-estoque/GerenciarProdutosCentroEstoque"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "PedidoConsumivelCentroEstoque",
        path: "dashboard/pedidosConsumivelCentroEstoque",
        component: () =>
          import(
            "@/components/recursos/pedido-consumivel-centro-estoque/ListagemPedidos"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "FuncionarioDocumentacaoAcessoria",
        path: "dashboard/funcionarioDocumentacaoAcessoria",
        component: () =>
          import(
            "@/components/pessoal/funcionario-documentacao-acessoria/ListagemFuncionarioDocumentacaoAcessoria"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },

      {
        name: "AssistenciaTecnicaTipo",
        path: "dashboard/assistenciaTecnicaTipo",
        component: () =>
          import(
            "@/components/operacoes/assistenciaTecnicaTipo/ListagemAssistenciaTecnicaTipo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      {
        name: "RoteirizadorZonaTrafego",
        path: "dashboard/roteirizadorZonaTrafego",
        redirect: { name: "Roteirizador" },
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      {
        name: "RoteirizadorParametro",
        path: "dashboard/roteirizadorParametro",
        component: () =>
          import(
            "@/components/operacoes/roteirizadorParametro/ListagemRoteirizadorParametro"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      {
        name: "Roteirizador",
        path: "dashboard/roteirizacao",
        component: () => import("@/components/operacoes/roteiros/Roteirizacao"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Operacoes",
        },
      },

      {
        name: "TarefaClassificacao",
        path: "dashboard/tarefaClassificacao",
        component: () =>
          import(
            "@/components/operacoes/tarefa-classificacao/ListagemTarefaClassificacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tarefas",
        },
      },

      {
        name: "TarefaClassificacaoAgrupamento",
        path: "dashboard/tarefaClassificacaoAgrupamento",
        component: () =>
          import(
            "@/components/operacoes/tarefa-classificacao-agrupamento/ListagemTarefaClassificacaoAgrupamento"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tarefas",
        },
      },

      {
        name: "TarefaSolicitacao",
        path: "dashboard/tarefaSolicitacao",
        component: () =>
          import(
            "@/components/operacoes/tarefa-solicitacao/ListagemTarefaSolicitacao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tarefas",
        },
      },
      {
        name: "TarefaExecucao",
        path: "dashboard/tarefaExecucao",
        component: () =>
          import(
            "@/components/operacoes/tarefa-execucao/ListagemTarefaExecucao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tarefas",
        },
      },
      {
        name: "TarefaExecucaoItem",
        path: "dashboard/tarefaExecucao/acompanhamento",
        component: () =>
          import(
            "@/components/operacoes/tarefa-execucao-item/ListagemTarefaExecucaoItem"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tarefas",
        },
      },
      {
        name: "PostoTrabalhoOcorrencias",
        path: "dashboard/postoTrabalhoOcorrencias",
        component: () =>
          import(
            "@/components/comercial/posto-trabalho-ocorrencias/ListagemPostoTrabalhoOcorrencia"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },
      {
        name: "RegistradorPontoExterno",
        path: "dashboard/registradorPontoExterno",
        component: () =>
          import(
            "@/components/pessoal/registrador-ponto-externo/ListagemRegistradorPontoExterno"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },

      {
        name: "PontoFacultativo",
        path: "dashboard/pontosFacultativo",
        component: () =>
          import(
            "@/components/software/pontosFacultativo/ListagemPontoFacultativo"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Software",
        },
      },

      {
        name: "TarefaExecucaoPeriodo",
        path: "dashboard/tarefaExecucao/acompanhamento/periodo",
        component: () =>
          import(
            "@/components/operacoes/tarefa-execucao/ListagemPeriodoTarefaExecucao"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tarefas",
        },
      },

      {
        name: "ProdutoTransporte",
        path: "dashboard/faturamento/produtoTransporte",
        component: () =>
          import(
            "@/components/faturamento/produto-transporte/ListagemProdutoTransporte"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Tarefas",
        },
      },

      {
        name: "PlanejamentoCompraUniformes",
        path: "dashboard/uniformes/planejamentoCompra",
        component: () =>
          import(
            "@/components/recursos/pedido-uniforme/PlanejamentoCompraSubstituicaoUniformes"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "UniformeSubstituicao",
        path: "dashboard/uniformes/substituicao",
        component: () =>
          import(
            "@/components/recursos/pedido-uniforme/PlanejamentoCompraSubstituicaoUniformes"
          ),
        props: {
          origemInicial: "substituicao",
        },
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "DashboardUniformes",
        path: "dashboard/uniformes/dashboard",
        component: () =>
          import("@/components/recursos/pedido-uniforme/DashboardUniformes"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Recursos",
        },
      },
      {
        name: "DashboardFaturamento",
        path: "dashboard/faturamento/dashboard",
        component: () =>
          import("@/components/faturamento/DashboardFaturamento"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },
      {
        name: "CurvaABCFaturamento",
        path: "dashboard/faturamento/curva-abc",
        component: () =>
          import("@/components/faturamento/RelatorioCurvaABCFaturamento"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Faturamento",
        },
      },
      {
        path: "dashboard/financeiro/dashboard",
        redirect: "/dashboard/faturamento/dashboard",
        beforeEnter: ifAuthenticated,
      },

      {
        name: "ComunicacaoInterna",
        path: "dashboard/comunicacaoInterna",
        component: () =>
          import(
            "@/components/pessoal/comunicacao-interna/ListagemComunicacaoInterna"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Pessoal",
        },
      },

      {
        name: "SuporteAtendimento",
        path: "dashboard/suporte/atendimento",
        component: () => import("@/components/support/SupportApp.vue"),
        beforeEnter: ifAuthenticatedSupportAttendant,
        meta: {
          groupName: "Suporte",
          supportScope: SUPPORT_SCOPE_PROJECT,
        },
      },
      {
        name: "SuporteDashboard",
        path: "dashboard/suporte/dashboard",
        component: () =>
          import("@/components/support/DashboardTicketsSuporte.vue"),
        beforeEnter: ifAuthenticatedSupportList,
        meta: {
          groupName: "Suporte",
          supportScope: SUPPORT_SCOPE_PROJECT,
        },
      },
      {
        name: "SuporteTickets",
        path: "dashboard/suporte/tickets",
        component: () =>
          import("@/components/support/ListagemTicketsSuporte.vue"),
        beforeEnter: ifAuthenticatedSupportList,
        meta: {
          groupName: "Suporte",
          supportScope: SUPPORT_SCOPE_PROJECT,
        },
      },
      {
        name: "SuporteClienteDashboard",
        path: "dashboard/chamados/dashboard",
        component: () =>
          import("@/components/support/DashboardTicketsCliente.vue"),
        beforeEnter: ifAuthenticatedSupportClient,
        meta: {
          groupName: "SuporteCliente",
        },
      },
      {
        name: "SuporteClienteChamados",
        path: "dashboard/chamados",
        component: () =>
          import("@/components/support/ListagemTicketsCliente.vue"),
        beforeEnter: ifAuthenticatedSupportClient,
        meta: {
          groupName: "SuporteCliente",
        },
      },
      {
        name: "SuporteInternoAtendimento",
        path: "dashboard/suporte-interno/atendimento",
        component: () => import("@/components/support/SupportApp.vue"),
        beforeEnter: ifAuthenticatedSupportAttendant,
        meta: {
          groupName: "SuporteInterno",
          supportScope: SUPPORT_SCOPE_INTERNAL,
        },
      },
      {
        name: "SuporteInternoDashboard",
        path: "dashboard/suporte-interno/dashboard",
        component: () =>
          import("@/components/support/DashboardTicketsSuporte.vue"),
        beforeEnter: ifAuthenticatedSupportList,
        meta: {
          groupName: "SuporteInterno",
          supportScope: SUPPORT_SCOPE_INTERNAL,
        },
      },
      {
        name: "SuporteInternoTickets",
        path: "dashboard/suporte-interno/tickets",
        component: () =>
          import("@/components/support/ListagemTicketsSuporte.vue"),
        beforeEnter: ifAuthenticatedSupportList,
        meta: {
          groupName: "SuporteInterno",
          supportScope: SUPPORT_SCOPE_INTERNAL,
        },
      },
      {
        name: "SupportTeamMembersInterno",
        path: "dashboard/suporte-interno/equipe",
        component: ListagemSupportTeamMembers,
        beforeEnter: ifAuthenticatedSupportConfiguration(
          "ROLE_SupportTeamMember_List"
        ),
        meta: {
          groupName: "SuporteInterno",
          supportScope: SUPPORT_SCOPE_INTERNAL,
        },
      },
      {
        name: "SupportSubjectsInterno",
        path: "dashboard/suporte-interno/assuntos",
        component: ListagemSupportSubjects,
        beforeEnter: ifAuthenticatedSupportConfiguration(
          "ROLE_SupportSubject_List"
        ),
        meta: {
          groupName: "SuporteInterno",
          supportScope: SUPPORT_SCOPE_INTERNAL,
        },
      },
      {
        name: "SupportTeamMembers",
        path: "dashboard/suporte/equipe",
        component: ListagemSupportTeamMembers,
        beforeEnter: ifAuthenticatedSupportConfiguration(
          "ROLE_SupportTeamMember_List"
        ),
        meta: {
          groupName: "Suporte",
          supportScope: SUPPORT_SCOPE_PROJECT,
        },
      },
      {
        name: "SupportSubjects",
        path: "dashboard/suporte/assuntos",
        component: ListagemSupportSubjects,
        beforeEnter: ifAuthenticatedSupportConfiguration(
          "ROLE_SupportSubject_List"
        ),
        meta: {
          groupName: "Suporte",
          supportScope: SUPPORT_SCOPE_PROJECT,
        },
      },
      {
        name: "SupportHorarioAtendimento",
        path: "dashboard/suporte/horario-atendimento",
        component: () =>
          import(
            "@/components/support/support-horario-atendimento/ConfiguracaoHorarioAtendimento.vue"
          ),
        beforeEnter: ifAuthenticatedSupportConfiguration(
          "ROLE_SupportHorarioAtendimento_List"
        ),
        meta: {
          groupName: "Suporte",
          supportScope: SUPPORT_SCOPE_PROJECT,
        },
      },
      {
        name: "SupportHorarioAtendimentoInterno",
        path: "dashboard/suporte-interno/horario-atendimento",
        component: () =>
          import(
            "@/components/support/support-horario-atendimento/ConfiguracaoHorarioAtendimento.vue"
          ),
        beforeEnter: ifAuthenticatedSupportConfiguration(
          "ROLE_SupportHorarioAtendimento_List"
        ),
        meta: {
          groupName: "SuporteInterno",
          supportScope: SUPPORT_SCOPE_INTERNAL,
        },
      },
      {
        name: "SupportAiConfiguracao",
        path: "dashboard/suporte-interno/atendimento-ia",
        component: () =>
          import(
            "@/components/support/support-ai-configuracao/ConfiguracaoAtendimentoIa.vue"
          ),
        beforeEnter: ifAuthenticatedSupportConfiguration(
          "ROLE_SupportAiConfiguracao_List"
        ),
        meta: {
          groupName: "SuporteInterno",
          supportScope: SUPPORT_SCOPE_INTERNAL,
        },
      },
      {
        name: "TutorialProcessos",
        path: "dashboard/suporte/tutoriais",
        component: () => import("@/components/tutorials/TutorialProcessos.vue"),
        beforeEnter: ifAuthenticatedTutorialAdmin,
        meta: {
          groupName: "Suporte",
        },
      },
      {
        name: "cadastro.supportteammember",
        path: "dashboard/suporte/equipe/cadastro",
        component: CadastroSupportTeamMember,
        beforeEnter: ifAuthenticatedSupportConfiguration(
          "ROLE_SupportTeamMember_Insert"
        ),
        meta: {
          groupName: "Suporte",
          supportScope: SUPPORT_SCOPE_PROJECT,
        },
      },
      {
        name: "editar.supportteammember",
        path: "dashboard/suporte/equipe/:id/editar",
        component: EditarSupportTeamMember,
        beforeEnter: ifAuthenticatedSupportConfiguration(
          "ROLE_SupportTeamMember_Update"
        ),
        meta: {
          groupName: "Suporte",
          supportScope: SUPPORT_SCOPE_PROJECT,
        },
      },
      {
        name: "cadastro.supportsubject",
        path: "dashboard/suporte/assuntos/cadastro",
        component: CadastroSupportSubject,
        beforeEnter: ifAuthenticatedSupportConfiguration(
          "ROLE_SupportSubject_Insert"
        ),
        meta: {
          groupName: "Suporte",
          supportScope: SUPPORT_SCOPE_PROJECT,
        },
      },
      {
        name: "editar.supportsubject",
        path: "dashboard/suporte/assuntos/:id/editar",
        component: EditarSupportSubject,
        beforeEnter: ifAuthenticatedSupportConfiguration(
          "ROLE_SupportSubject_Update"
        ),
        meta: {
          groupName: "Suporte",
          supportScope: SUPPORT_SCOPE_PROJECT,
        },
      },
      {
        name: "Suporte",
        path: "dashboard/suporte",
        component: () => import("@/components/support/SupportUserApp.vue"),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Suporte",
        },
      },

      {
        name: "FuncionarioRegistrador",
        path: "dashboard/funcionarioRegistrador",
        component: () =>
          import(
            "@/components/pessoal/funcionario-registrador/ListagemFuncionarioRegistrador.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Suporte",
        },
      },
      {
        name: "FuncionarioPontoWeb",
        path: "dashboard/funcionarioPontoWeb",
        component: () =>
          import(
            "@/components/pessoal/funcionario-ponto-web/ListagemFuncionarioPontoWeb.vue"
          ),
        beforeEnter: ifAuthenticated,
        meta: {
          groupName: "Suporte",
        },
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // Rotas de módulo contratado: sem o módulo na empresa atual, volta ao painel.
  if (to.meta?.modulo) {
    if (!store.getters.isAuthenticated) return next("/login");
    if (!hasModulo(to.meta.modulo, store.state)) return next("/dashboard");
  }
  // Rotas de uma permissão específica: sem ela, volta ao painel.
  if (to.meta?.permissao) {
    if (!store.getters.isAuthenticated) return next("/login");
    if (!hasPermission(to.meta.permissao, store.state.permissoes || []))
      return next("/dashboard");
  }
  // Telas do grupo com regra própria (Certidões, Rotinas internas) seguem só a regra delas.
  if (
    to.meta?.groupName === "CLP" &&
    !to.meta?.modulo &&
    !to.meta?.permissao
  ) {
    if (!store.getters.isAuthenticated) return next("/login");
    if (!podeOportunidades(store.state, to.meta.oportunidadeAcao || "List")) return next("/dashboard");
  }
  const tokenFromAddressBar = getPasswordRecoveryTokenFromAddressBar();
  if (tokenFromAddressBar) {
    const routeToken = to?.query?.token ? String(to.query.token).trim() : "";
    const shouldRedirectToRecoveryRoute =
      to.path !== "/recuperar-senha" && isPasswordRecoveryPathInAddressBar();

    if (shouldRedirectToRecoveryRoute) {
      next({
        path: "/recuperar-senha",
        query: { ...to.query, token: tokenFromAddressBar },
        replace: true,
      });
      return;
    }

    if (to.path === "/recuperar-senha" && routeToken !== tokenFromAddressBar) {
      next({
        path: "/recuperar-senha",
        query: { ...to.query, token: tokenFromAddressBar },
        replace: true,
      });
      return;
    }
  }

  if (isPasswordRecoveryWithToken(to, tokenFromAddressBar)) {
    next();
    return;
  }

  if (
    store.getters.isAuthenticated &&
    store.getters.isPasswordChangeRequired &&
    !isPasswordChangeRoute(to)
  ) {
    const redirect = to?.path && to.path !== "/dashboard" ? to.fullPath : null;
    next({
      path: PASSWORD_CHANGE_PATH,
      query: {
        senhaExpirada: "1",
        ...(redirect ? { redirect } : {}),
      },
      replace: true,
    });
    return;
  }

  if (to.meta?.groupName === "ESocial") {
    if (!store.getters.isAuthenticated) return next("/login");
    if (
      !userHasPermission("ROLE_MENU_ESocial") ||
      !userHasPermission(to.meta.permission)
    ) {
      return next("/dashboard");
    }
  }

  next();
});

export default router;
